export default {
  en: {
    language: 'Language',

    // Nav
    browse: 'Browse',
    library: 'Library',
    account: 'My account',
    back: 'Go Back',
    more: 'more',

    // Guides
    guide: 'Guide | Guides',
    views: 'Views',
    table_of_contents: 'Table of contents',
    reading_time: 'Reading time',
    date_added: 'Date added',
    date_updated: 'Date updated',
    minutes_read: 'Min read',
    published: 'Published',

    // Users
    joined: 'Joined',
    last_online: 'Last online',
    online: 'Online',
    created: 'created',
    followers: 'Followers',
    partner: 'Partner',
    profile_hidden: `This user's profile is hidden`,

    // Mods
    mod: 'Mod | Mods',
    level: 'Level | Levels',
    content: 'Content',
    subscribed: 'Subscribed',
    tags: 'Tags',
    summary: 'Summary',
    contributors: 'Contributors',
    description: 'Description',
    dependencies: 'Dependencies',
    of: 'of',
    ago: 'ago',
    and: 'and',
    by: 'By',
    reset_filters: 'Reset Filters',
    show_more: 'Show More',
    show_less: 'Show Less',
    no_ugc_found: 'No {ugc_name} found',
    no_subscriptions: 'You have not subscribed to any {ugc_name}',
    mod_disclaimer_heading: 'Legal disclaimer',
    mod_disclaimer_privacy: 'Privacy Policy',
    thumbs_up_received: 'Thumbs up received',
    thumbs_up: 'Thumbs up',
    total_downloads: 'Total downloads',
    releases: 'Releases',
    bytes: 'bytes',

    // Actions
    login: 'Login',
    logout: 'Log out',
    search: 'Search',
    clear_all: 'Clear all',
    download: 'Download',
    subscribe: 'Subscribe',
    unsubscribe: 'Unsubscribe',
    resubscribe: 'Resubscribe',
    activate: 'Activate',
    deactivate: 'Deactivate',
    like: 'Like',
    dislike: 'Dislike',
    report: 'Report a problem',
    submit: 'Submit',
    cancel: 'Cancel',

    // Filters
    all: 'All',
    available: 'available',
    filesize: 'File size',
    downloads: 'Downloads',
    todays_downloads: "Today's downloads",
    subscribers: 'Subscribers',
    rating: 'Rating',
    sort_by: 'Sort by',
    creator: 'Creator',
    apply: 'Apply',
    reset: 'Reset',
    featured: 'Featured',
    toggle_filters: 'Toggle filters',
    hidden: 'Hidden',
    pending: 'Pending',
    deleted: 'Deleted',

    // Login
    signup: 'Log in or sign up with Email',
    login_with: 'Log in with {service}',
    email_placeholder: 'Email address',
    code_placeholder: '5 digit code',
    have_code: 'I have a code',
    email_code: 'Email code',
    send_new_code: 'Send new code',
    check_email: 'Please check your email for your code and enter it here.',
    login_disclaimer: 'User-generated content for {game} is managed by mod.io.',
    terms_disclaimer: ` By pressing "Log in", you agree to the {studioterms}{terms} and {privacy} of mod.io and confirm you are {min_age} years of age or older.`,
    terms_disclaimer_studio: '{terms} of {studio}, the ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' and ',
    code_error: 'Unable to request code.',
    or: 'or',

    // Terms
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    aup: 'Acceptable Use Policy',
    monetization: 'Monetization Terms',
    game: 'Game Terms',
    api: 'API Access Terms',
    effective: 'Effective from',

    // Report
    report_heading: 'Report this mod',
    report_intro:
      "Report content violating the site's {terms} or submit a {dmca} using the form below. Make sure you include all relevant information and links.",
    dmca: 'DMCA complaint',
    reason: 'Reason for reporting',
    urls: 'Offending URLs',
    urls_placeholder: 'URLs (1 per line)',
    company_or_name: 'Company or your Name',
    email: 'Email',
    address: 'Address',
    country: 'Country',
    country_placeholder: 'Select a country',
    details: 'Details of Infringement',
    details_placeholder:
      'To help us process your report, please provide as much detail and evidence as possible, including:\n\nURLs, dates, account names involved\nWhere the original content can be found\nThe infringement that has occurred',
    dmca_1:
      "{mod_io} respects the intellectual property rights of others, and we ask that everyone using our internet sites and services do the same. Anyone who believes that their work has been reproduced in one of our internet sites or services in a way that constitutes copyright infringement may notify mod.io's copyright agent using the form below.",
    dmca_2:
      'Submitting a claim of copyright infringement is a serious legal matter. Before you proceed, you might consider contacting the individual directly to address the complaint. It might be a simple misunderstanding and possible to address without involving proper legal process.',
    dmca_3:
      'Be aware that under Section 512(f) of the Digital Millennium Copyright Act, any person who knowingly materially misrepresents that material or activity is infringing may be liable for damages. Please also note that the information provided in this legal notice may be shared with third-parties or made public.',
    claim_check:
      'By checking the following boxes and submitting this claim, I state UNDER PENALTY OF PERJURY that',
    copyright_owner: 'I am the Copyright Owner',
    copyright_auth_owner:
      "I am authorized to act on the copyright owner's behalf in this situation.",
    authorization: 'Authorization',
    authorization_check:
      'I have a good faith belief that the use of the material noted in this claim is not authorized by the copyright owner, its agent, or the law.',
    acknowledgement: 'Acknowledgement',
    acknowledgement_check:
      'I acknowledge that under Section 512(f) of the DMCA any person who knowingly materially misrepresent that material or activity is infringing may be liable for damages.',
    required: 'required',
    signature: 'Signature',
    signature_placeholder:
      'Type your full name into this box, acting as your digital signature.',
    report_success_title: 'Your report has been received',
    report_success_text:
      'If your message requires a response, please be patient as we endeavour to reply to all reports within 48 hours of receiving them.',
    report_error_title: 'Failed to submit report',

    // Table
    name: 'Name',
    added: 'Added',
    updated: 'Updated',
    file: 'File',
    version: 'Version',
    actions: 'Actions',
    locally_installed: 'Locally installed',

    // Releases
    download_from_game_client: 'Download {mod} from game client',
    release_notes: 'Release Notes',
    no_release_notes: 'No release notes provided',
    previous_releases: 'Previous releases',
    view_previous_releases: 'View previous releases',
    no_previous_releases: 'There are no previous releases',
    no_files_published: 'No files published',
    download_files_manually: 'Download files manually',
    platforms: 'Platforms',

    // Ratings
    overwhelmingly_positive: 'Overwhelmingly positive',
    overwhelmingly_negative: 'Overwhelmingly negative',
    very_positive: 'Very positive',
    very_negative: 'Very negative',
    mostly_positive: 'Mostly positive',
    mostly_negative: 'Mostly negative',
    negative: 'Negative',
    positive: 'Positive',
    mixed: 'Mixed',
    unrated: 'Unrated',

    // Sort
    sort_comments: 'Comments',
    sort_total_mods: 'Total Mods',
    sort_trending: 'Trending',
    sort_highest_rated: 'Highest Rated',
    sort_most_popular: 'Popular',
    sort_most_subscribers: 'Most Subscribers',
    sort_recently_added: 'Recent',
    sort_last_updated: 'Last Updated',
    sort_alphabetical: 'Alphabetical',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'Not Working',
    report_rude_content: 'Rude Content',
    report_illegal_content: 'Illegal Content',
    report_stolen_content: 'Stolen Content',
    report_false_information: 'False Information',
    report_other: 'Other',

    // Errors
    login_fail: 'Failed to login',
    login_fail_message: 'Failed to login. Please wait a minute and try again.',
    subscribe_fail: 'Failed to subscribe',
    unsubscribe_fail: 'Failed to unsubscribe',

    filter: 'Filter',
    page_not_found: 'Page not found!',
    take_me_home: 'Take me home',
    previous_version: 'Previous version',
    next_version: 'Next version',
    agreement_not_found: 'Agreement not found',
    loading: 'Loading',
    no_results_found: 'No results found',
    validation_required: 'Field is required',
    validation_checked: 'Field must be checked',
    validation_email: 'Field must be an email',
    validation_max: 'Maximum {max} characters',
    validation_url: 'Field must be a URL',
    validation_size: 'Field must be {size} characters',
    validation_alpha_num: 'Field can only contain numbers or letters',
    validation_name: 'Field can only contain letters and name-related symbols',

    form_chars_remaining: '{count} characters remaining.',
    form_not_enough_chars: '{count} more characters required.',

    // Comments
    comment: 'comment | comments',
    team_member: 'Team member',
    author: 'Author',
    good_karma: 'Good karma',
    bad_karma: 'Bad karma',
    reply: 'Reply',
    replies: 'reply | replies',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    post: 'Post',
    pinned: 'Pinned',
    locked: 'Locked',
    add_comment: 'Add a comment...',
    comment_login_prompt: 'Log in to join the discussion!',
    comment_error_add: 'Failed to add comment',
    comment_error_edit: 'Failed to edit comment',
    comment_error_delete: 'Failed to delete comment',
    comments_error_fetch: 'Failed to load more comments',
    discussion: 'Discussion',
    load_more_comments: 'Load more comments',
    comment_confirm_delete: 'Are you sure you want to delete this comment?',
    comment_deleted: 'The comment was successfully deleted',
  },
  fr: {
    language: 'Langue',

    // Nav
    browse: 'Parcourir',
    library: 'Bibliothèque',
    account: 'Mon compte',
    back: 'Retourner',
    more: 'plus',

    // Guides
    guide: 'Guide | Guides',
    views: 'Vues',
    table_of_contents: 'Table des matières',
    reading_time: 'Temps de lecture',
    date_added: 'Date ajoutée',
    date_updated: 'Date de mise à jour',
    minutes_read: 'Minute de lecture',
    published: 'Publié',

    // Users
    joined: 'Rejoint',
    last_online: 'Dernière connexion',
    online: 'En ligne',
    created: 'créé',
    followers: 'Suiveurs',
    partner: 'Partenaire',
    profile_hidden: 'Le profil de cet utilisateur est masqué',

    // Mods
    mod: 'Mod | Mods',
    level: 'Niveau | Les niveaux',
    content: 'Contenu',
    subscribed: 'Abonné',
    tags: 'Tags',
    summary: 'Résumé',
    contributors: 'Contributeurs',
    description: 'Description',
    dependencies: 'Dépendances',
    of: 'sur',
    ago: 'il y a',
    and: 'et',
    by: 'Par',
    reset_filters: 'Réinitialiser les filtres',
    show_more: 'Montre plus',
    show_less: 'Afficher moins',
    no_ugc_found: 'Aucun {ugc_name} trouvé',
    no_subscriptions: "Vous n'êtes abonné à aucun {ugc_name}",
    mod_disclaimer_heading: 'Mentions légales',
    mod_disclaimer_privacy: "Charte d'utilisation des données personnelles",
    thumbs_up_received: 'Bravo reçu',
    thumbs_up: 'Pouces vers le haut',
    total_downloads: 'Total des téléchargements',
    releases: 'Sorties',
    bytes: 'octets',

    // Actions
    login: 'Connexion',
    logout: 'Déconnexion',
    search: 'Recherche',
    clear_all: 'Réinitialiser',
    download: 'Télécharger',
    subscribe: "S'abonner",
    unsubscribe: 'Se désabonner',
    resubscribe: 'Se réabonner',
    activate: 'Activer',
    deactivate: 'Désactiver',
    like: "J'aime",
    dislike: "Je n'aime pas",
    report: 'Signaler un problème',
    submit: 'Envoyer',
    cancel: 'Annuler',

    // Filters
    all: 'Tous',
    available: 'disponible(s)',
    filesize: 'Taille du fichier',
    downloads: 'Téléchargements',
    todays_downloads: 'Téléchargements du jour',
    subscribers: 'Abonnés',
    rating: 'Notation',
    sort_by: 'Trier par',
    creator: 'Créateur',
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    featured: 'En vedette',
    toggle_filters: 'Faire basculer les filtres',
    hidden: 'Caché',
    pending: 'En attente',
    deleted: 'Supprimé',

    // Login
    signup: 'Connectez-vous ou inscrivez-vous avec votre adresse e-mail',
    login_with: 'Connectez-vous avec {service}',
    email_placeholder: 'Adresse e-mail',
    code_placeholder: 'Code à 5 chiffres',
    have_code: "J'ai un code",
    email_code: 'Envoyer un code par e-mail',
    send_new_code: 'Envoyer un nouveau code',
    check_email:
      'Veuillez consulter votre boîte e-mail et saisissez ici le code reçu.',
    login_disclaimer:
      "Le contenu généré par l'utilisateur pour {game} est géré par mod.io.",
    terms_disclaimer: `En appuyant sur « Connectez-vous », vous acceptez les {studioterms}{terms} et la {privacy} de mod.io et confirmez que vous avez {min_age} ans ou plus.`,
    terms_disclaimer_studio: '{terms} de {studio}, les ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' et la ',
    code_error: 'Demande de code impossible.',
    or: 'ou',

    // Terms
    terms: "Conditions d'utilisation",
    privacy: 'Politique de confidentialité',
    aup: "Politique d'utilisation acceptable",
    monetization: 'Conditions de monétisation',
    game: 'Conditions du jeu',
    api: "Conditions d'accès à l'API",
    effective: 'En vigueur à partir de',

    // Report
    report_heading: 'Signaler ce mod',
    report_intro:
      "Signalez du contenu qui ne respecte pas les {terms} du site ou envoyez une {dmca} en utilisant le formulaire ci-dessous. Assurez-vous d'inclure toutes les informations et tous les liens pertinents.",
    dmca: 'Plainte propriété intellectuelle',
    reason: 'Raison du signalement',
    urls: 'URL incriminées',
    urls_placeholder: 'URL (1 par ligne)',
    company_or_name: 'Société ou votre nom',
    email: 'Adresse e-mail',
    address: 'Adresse',
    country: 'Pays',
    country_placeholder: 'Sélectionnez un pays',
    details: "Détails de l'infraction",
    details_placeholder:
      "Pour nous aider à traiter votre signalement, veuillez fournir autant de détails et de preuves que possible, y compris:\n\nLes URL, les dates, les noms des comptes impliqués\nOù trouver le contenu original\nL'infraction qui s'est produite",
    dmca_1:
      "{mod_io} respecte les droits de propriété intellectuelle d'autrui et nous demandons à tous ceux qui utilisent nos sites et services Internet de faire de même. Toute personne qui estime que son travail a été reproduit sur l'un de nos sites Internet ou services d'une manière qui constitue une violation du droit d'auteur peut en informer l'agent des droits d'auteur de mod.io en utilisant le formulaire ci-dessous.",
    dmca_2:
      "Soumettre une réclamation pour infraction au droit d'auteur est une affaire juridique sérieuse. Avant de poursuivre, vous pouvez envisager de contacter directement la personne pour résoudre la plainte. Il peut s'agir d'un simple malentendu qui puisse être résolu sans impliquer une procédure judiciaire appropriée.",
    dmca_3:
      "Sachez qu'en vertu de l'article 512 (f) de la loi Digital Millennium Copyright Act, toute personne qui déclare faussement, sciemment et/ou matériellement que le matériel ou l'activité est en infraction peut être tenue responsable des dommages. Veuillez également noter que les informations fournies dans la présente notice légale peuvent être partagées avec des tiers ou rendues publiques.",
    claim_check:
      'En cochant les cases suivantes et en soumettant cette réclamation, je déclare SOUS PEINE DE PARJURE que',
    copyright_owner: "Je suis le titulaire du droit d'auteur",
    copyright_auth_owner:
      "J'ai l'autorisation d'agir au nom du titulaire du droit d'auteur dans cette situation.",
    authorization: 'Autorisation',
    authorization_check:
      "Je crois en toute bonne foi que l'utilisation du matériel indiqué dans cette réclamation n'est pas autorisée par le titulaire du droit d'auteur, son agent ou la loi.",
    acknowledgement: 'Reconnaissance',
    acknowledgement_check:
      "Je reconnais qu'en vertu de l'article 512 (f) du DMCA, toute personne qui déclare faussement, sciemment et/ou matériellement que le matériel ou l'activité est en infraction peut être tenue responsable des dommages.",
    required: 'requis',
    signature: 'Signature',
    signature_placeholder:
      'Saisissez votre nom complet dans cette case, agissant comme votre signature numérique.',
    report_success_title: 'Votre signalement a été reçu',
    report_success_text:
      'Si votre message nécessite une réponse, veuillez patienter car nous nous efforçons de répondre à tous les signalements dans les 48 heures suivant leur réception.',
    report_error_title: "Échec de l'envoi du signalement",

    // Table
    name: 'Nom',
    added: 'Ajouté',
    updated: 'Mis à jour',
    file: 'Fichier',
    version: 'Version',
    actions: 'Actions',
    locally_installed: 'Installé localement',

    // Releases
    download_from_game_client: 'Télécharger {mod} depuis le client du jeu',
    release_notes: 'Notes de version',
    no_release_notes: 'Aucune note de version fournie',
    previous_releases: 'Versions précédentes',
    view_previous_releases: 'Voir les versions précédentes',
    no_previous_releases: 'Aucune version précédente',
    no_files_published: 'Aucun fichier publié',
    download_files_manually: 'Télécharger des fichiers manuellement',
    platforms: 'Plateformes',

    // Ratings
    overwhelmingly_positive: 'Extrêmement positif',
    overwhelmingly_negative: 'Extrêmement négatif',
    very_positive: 'Très positif',
    very_negative: 'Très négatif',
    mostly_positive: 'Plutôt positif',
    mostly_negative: 'Plutôt négatif',
    negative: 'Négatif',
    positive: 'Positif',
    mixed: 'Mixte',
    unrated: 'Non classé',

    // Sort
    sort_comments: 'Commentaires',
    sort_total_mods: 'Mods totaux',
    sort_trending: 'Tendance',
    sort_highest_rated: 'Les mieux notés',
    sort_most_popular: 'Le plus populaire',
    sort_most_subscribers: "Le plus d'abonnés",
    sort_recently_added: 'Récemment ajouté',
    sort_last_updated: 'Dernière mise à jour',
    sort_alphabetical: 'Alphabétique',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'Ne fonctionne pas',
    report_rude_content: 'Contenu inapproprié',
    report_illegal_content: 'Contenu illégal',
    report_stolen_content: 'Contenu volé',
    report_false_information: 'Informations fausses',
    report_other: 'Autre',

    // Errors
    login_fail: 'Échec de la connexion',
    login_fail_message:
      'Échec de la connexion. Veuillez attendre une minute et réessayer.',
    subscribe_fail: "Échec de l'abonnement",
    unsubscribe_fail: 'Échec de la désabonnement',

    agreement_not_found: 'Accord introuvable',
    form_chars_remaining: '{count} caractères restants.',
    form_not_enough_chars: '{count} plus de caractères requis.',
    filter: 'Filtre',
    loading: 'Chargement',
    next_version: 'Version suivante',
    no_results_found: 'Aucun résultat trouvé',
    page_not_found: 'Page non trouvée!',
    previous_version: 'La version précédente',
    take_me_home: 'Emmène moi chez toi',
    validation_alpha_num:
      'Le champ ne peut contenir que des chiffres ou des lettres',
    validation_size: 'Le champ doit contenir {size} caractères',
    validation_url: 'Le champ doit être une URL',
    validation_max: 'Caractères maximum {max}',
    validation_email: 'Le champ doit être un e-mail',
    validation_checked: 'Le champ doit être vérifié',
    validation_required: 'Champ requis',
    validation_name:
      'Le champ ne peut contenir que des lettres et des symboles liés au nom',

    comment: 'commentaire | commentaires',
    team_member: "Membre de l'équipe",
    author: 'Auteur',
    good_karma: 'Bon karma',
    bad_karma: 'Mauvais karma',
    reply: 'Répondre',
    replies: 'réponse | réponses',
    save: 'Sauvegarder',
    delete: 'Supprimer',
    edit: 'Modifier',
    post: 'Poste',
    pinned: 'Épinglé',
    locked: 'Fermé à clé',
    add_comment: 'Ajouter un commentaire...',
    comment_login_prompt: 'Connectez-vous pour rejoindre la discussion!',
    comment_error_add: "Échec de l'ajout de commentaires",
    comment_error_edit: 'Échec de la modification du commentaire',
    comment_error_delete: 'Échec de la suppression des commentaires',
    comments_error_fetch: 'Échec du chargement de plus de commentaires',
    discussion: 'Discussion',
    load_more_comments: 'Chargez plus de commentaires',
    comment_confirm_delete:
      'êtes-vous sûr de vouloir supprimer ce commentaire?',
    comment_deleted: 'Le commentaire a été supprimé avec succès',
  },
  de: {
    language: 'Sprache',

    // Nav
    browse: 'Durchsuchen',
    library: 'Bibliothek',
    account: 'Mein Konto',
    back: 'Geh zurück',
    more: 'mehr',

    // Guides
    guide: 'Leitfaden | Führer',
    views: 'Ansichten',
    table_of_contents: 'Inhaltsverzeichnis',
    reading_time: 'Lesezeit',
    date_added: 'Datum hinzugefügt',
    date_updated: 'Datum aktualisiert',
    minutes_read: 'Minutenablesung',
    published: 'Veröffentlicht',

    // Users
    joined: 'Beigetreten',
    last_online: 'Zuletzt Online',
    online: 'Online',
    created: 'erstellt',
    followers: 'Anhänger',
    partner: 'Partner',
    profile_hidden: 'Das Profil dieses Benutzers ist ausgeblendet',

    // Mods
    mod: 'Mod | Mods',
    level: 'Ebene | Ebenen',
    content: 'Inhalt',
    subscribed: 'Abonniert',
    tags: 'Tags',
    summary: 'Zusammenfassung',
    contributors: 'Mitwirkende',
    description: 'Beschreibung',
    dependencies: 'Abhängigkeiten',
    of: 'von',
    ago: 'vor',
    and: 'und',
    by: 'Von',
    reset_filters: 'Filter zurücksetzen',
    show_more: 'Zeig mehr',
    show_less: 'Weniger anzeigen',
    no_ugc_found: 'Kein {ugc_name} gefunden',
    no_subscriptions: 'Sie haben kein {ugc_name} abonniert',
    mod_disclaimer_heading: 'Rechtlicher Hinweis',
    mod_disclaimer_privacy: 'Datenschutzerklärung',
    thumbs_up_received: 'Daumen hoch erhalten',
    thumbs_up: 'Daumen hoch',
    total_downloads: 'Gesamtzahl der Downloads',
    releases: 'Veröffentlichungen',
    bytes: 'Bytes',

    // Actions
    login: 'Anmelden',
    logout: 'Abmelden',
    search: 'Suchen',
    clear_all: 'Alle löschen',
    download: 'Herunterladen',
    subscribe: 'Abonnieren',
    unsubscribe: 'Nicht mehr abonnieren',
    resubscribe: 'Erneut abonnieren',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    like: 'Gefällt mir',
    dislike: 'Gefällt mir nicht',
    report: 'Ein Problem melden',
    submit: 'Absenden',
    cancel: 'Abbrechen',

    // Filters
    all: 'Alle',
    available: 'verfügbar',
    filesize: 'Dateigröße',
    downloads: 'Downloads',
    todays_downloads: 'Heutige Downloads',
    subscribers: 'Abonnenten',
    rating: 'Bewertung',
    sort_by: 'Sortieren nach',
    creator: 'Creator',
    apply: 'Anwenden',
    reset: 'Zurücksetzen',
    featured: 'Vorgestellt',
    toggle_filters: 'Filter umschalten',
    hidden: 'Versteckt',
    pending: 'Ausstehend',
    deleted: 'Gelöscht',

    // Login
    signup: 'Anmelden oder mit E-Mail-Adresse registrieren',
    login_with: 'Anmelden Sie sich mit {service} an',
    email_placeholder: 'E-Mail-Adresse',
    code_placeholder: '5-stelliger Code',
    have_code: 'Ich habe einen Code',
    email_code: 'Code per E-Mail senden',
    send_new_code: 'Neuen Code senden',
    check_email:
      'Bitte prüfen Sie Ihr E-Mail-Postfach auf Ihren Code und geben Sie ihn hier ein.',
    login_disclaimer:
      'Benutzergenerierte Inhalte für {game} werden von mod.io verwaltet.',
    terms_disclaimer: `Indem Sie auf „Anmelden“ klicken, stimmen Sie den {studioterms}{terms} und der {privacy} von mod.io zu und bestätigen, dass Sie mindestens {min_age} Jahre alt sind.`,
    terms_disclaimer_studio: '{terms} von {studio}, den ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' und ',
    code_error: 'Code kann nicht angefordert werden.',
    or: 'oder',

    // Terms
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutzerklärung',
    aup: 'Richtlinien zur akzeptablen Nutzung',
    monetization: 'Monetarisierungsbedingungen',
    game: 'Spielbedingungen',
    api: 'API-Zugriffsbedingungen',
    effective: 'Gültig ab',

    // Report
    report_heading: 'Diese Mod melden',
    report_intro:
      'Melden Sie Inhalte, die gegen die {terms} der Website verstoßen, oder reichen Sie eine {dmca} ein, indem Sie das Formular unten verwenden. Stellen Sie sicher, dass Sie alle relevanten Informationen und Links angeben.',
    dmca: 'DMCA-Beschwerde',
    reason: 'Grund für die Meldung',
    urls: 'Problematische URLs',
    urls_placeholder: 'URLs (eine pro Zeile)',
    company_or_name: 'Unternehmen oder Ihr Name',
    email: 'E-Mail',
    address: 'Adresse',
    country: 'Land',
    country_placeholder: 'Wählen Sie ein Land aus',
    details: 'Einzelheiten zum Verstoß',
    details_placeholder:
      'Um uns bei der Bearbeitung Ihrer Meldung zu helfen, geben Sie bitte so viele Details und Nachweise wie möglich an, einschließlich:\n\nder URLs, Daten, Namen der beteiligten Konten\ndes Orts, an dem der Originalinhalt gefunden werden kann\ndes Verstoßes, der stattgefunden hat',
    dmca_1:
      '{mod_io} respektiert die geistigen Eigentumsrechte anderer und wir bitten darum, dass jeder, der unsere Internet-Websites und Dienste nutzt, dies ebenfalls tut. Wenn Sie der Meinung sind, dass Ihr Werk auf einer unserer Internet-Websites oder im Rahmen eines unserer Dienste in einer Weise reproduziert wurde, die eine Urheberrechtsverletzung darstellt, können Sie den Vertreter für Urheberrechte bei mod.io über das unten stehende Formular informieren.',
    dmca_2:
      'Das Einreichen einer Beschwerde wegen Urheberrechtsverletzung ist eine ernste rechtliche Angelegenheit. Bevor Sie fortfahren, sollten Sie erwägen, die Person direkt zu kontaktieren, um das Problem anzusprechen. Möglicherweise handelt es sich um ein einfaches Missverständnis, das sich abseits des Rechtswegs klären lässt.',
    dmca_3:
      'Bitte beachten Sie, dass gemäß Abschnitt 512 (f) des Digital Millennium Copyright Act jede Person, die wissentlich falsche Angaben über die Rechtsverletzung von Material oder Aktivitäten macht, schadensersatzpflichtig sein kann. Bitte beachten Sie weiterhin, dass die in diesem rechtlichen Hinweis enthaltenen Informationen an Dritte weitergegeben oder veröffentlicht werden können.',
    claim_check:
      'Indem ich die folgenden Kästchen ankreuze und diese Beschwerde einreiche, erkläre ich UNTER ANDROHUNG VON STRAFE FÜR SCHULDHAFTES VERHALTEN, dass',
    copyright_owner: 'ich der Urheberrechtsinhaber bin',
    copyright_auth_owner:
      'ich berechtigt bin, in dieser Situation im Namen des Urheberrechtsinhabers zu handeln.',
    authorization: 'Genehmigung',
    authorization_check:
      'Ich bin in gutem Glauben davon überzeugt, dass die Verwendung des in dieser Beschwerde genannten Materials nicht durch den Urheberrechtsinhaber, dessen Vertreter oder das Gesetz genehmigt ist.',
    acknowledgement: 'Bestätigung',
    acknowledgement_check:
      'Ich erkenne an, dass gemäß Abschnitt 512 (f) des DMCA jede Person, die wissentlich falsche Angaben über die Rechtsverletzung von Material oder Aktivitäten macht, schadensersatzpflichtig sein kann.',
    required: 'erforderlich',
    signature: 'Unterschrift',
    signature_placeholder:
      'Geben Sie Ihren vollständigen Namen in dieses Feld ein, was als Ihre digitale Unterschrift dient.',
    report_success_title: 'Ihre Meldung ist eingegangen',
    report_success_text:
      'Falls Ihre Nachricht eine Antwort erfordert, haben Sie bitte etwas Geduld. Wir bemühen uns, alle Meldungen innerhalb von 48 Stunden nach Erhalt zu beantworten.',
    report_error_title: 'Fehler beim Senden der Meldung',

    // Table
    name: 'Name',
    added: 'Hinzugefügt',
    updated: 'Aktualisiert',
    file: 'Datei',
    version: 'Version',
    actions: 'Aktionen',
    locally_installed: 'Lokal installiert',

    // Releases
    download_from_game_client: '{mod} im Spielclient herunterladen',
    release_notes: 'Versionshinweise',
    no_release_notes: 'Keine Versionshinweise verfügbar',
    previous_releases: 'Vorherige Versionen',
    view_previous_releases: 'Frühere Veröffentlichungen anzeigen',
    no_previous_releases: 'Es gibt keine vorherigen Versionen',
    no_files_published: 'Keine Dateien veröffentlicht',
    download_files_manually: 'Laden Sie Dateien manuell herunter',
    platforms: 'Plattformen',

    // Ratings
    overwhelmingly_positive: 'Äußerst positiv',
    overwhelmingly_negative: 'Äußerst negativ',
    very_positive: 'Sehr positiv',
    very_negative: 'Sehr negativ',
    mostly_positive: 'Größtenteils positiv',
    mostly_negative: 'Größtenteils negativ',
    negative: 'Negativ',
    positive: 'Positiv',
    mixed: 'Gemischt',
    unrated: 'Keine Bewertung',

    // Sort
    sort_comments: 'Kommentare',
    sort_total_mods: 'Gesamtzahl der Mods',
    sort_trending: 'Im Trend',
    sort_highest_rated: 'Am besten bewertet',
    sort_most_popular: 'Am beliebtesten',
    sort_most_subscribers: 'Die meisten Abonnenten',
    sort_recently_added: 'Kürzlich hinzugefügt',
    sort_last_updated: 'Letzte Aktualisierung',
    sort_alphabetical: 'Alphabetisch',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'Funktioniert nicht',
    report_rude_content: 'Unhöflicher Inhalt',
    report_illegal_content: 'Illegaler Inhalt',
    report_stolen_content: 'Gestohlener Inhalt',
    report_false_information: 'Falsche Informationen',
    report_other: 'Andere',

    // Errors
    login_fail: 'Einloggen fehlgeschlagen',
    login_fail_message:
      'Einloggen fehlgeschlagen. Bitte warten Sie eine Minute und versuchen Sie es erneut.',
    subscribe_fail: 'Nicht abonnieren',
    unsubscribe_fail: 'Versäumnis, sich abzumelden',

    agreement_not_found: 'Vereinbarung nicht gefunden',
    form_chars_remaining: '{count} Zeichen verbleibend.',
    form_not_enough_chars: '{count} Weitere Zeichen erforderlich.',
    filter: 'Filtern',
    loading: 'Wird geladen',
    next_version: 'Nächste Version',
    no_results_found: 'keine Ergebnisse gefunden',
    page_not_found: 'Seite nicht gefunden!',
    previous_version: 'Vorherige Version',
    take_me_home: 'Bring mich nach Hause',
    validation_alpha_num: 'Feld kann nur Zahlen oder Buchstaben enthalten',
    validation_size: 'Das Feld muss {size} Zeichen sein',
    validation_url: 'Feld muss eine URL sein',
    validation_max: 'Maximum {max} Zeichen',
    validation_email: 'Das Feld muss eine E-Mail sein',
    validation_checked: 'Das Feld muss überprüft werden',
    validation_required: 'Feld ist erforderlich',
    validation_name:
      'Das Feld darf nur Buchstaben und namensbezogene Symbole enthalten',

    comment: 'Kommentar | Kommentare',
    team_member: 'Teammitglied',
    author: 'Autor',
    good_karma: 'Gutes Karma',
    bad_karma: 'Schlechtes Karma',
    reply: 'Antwort',
    replies: 'antworten | Antworten',
    save: 'Speichern',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    post: 'Post',
    pinned: 'Angepinnt',
    locked: 'Gesperrt',
    add_comment: 'Einen Kommentar hinzufügen...',
    comment_login_prompt: 'Melden Sie sich an, um der Diskussion beizutreten!',
    comment_error_add: 'Fehlte keinen Kommentar hinzufügen',
    comment_error_edit: 'Kommentar nicht bearbeiten',
    comment_error_delete: 'Kommentar nicht gelöscht',
    comments_error_fetch: 'Weitere Kommentare nicht laden',
    discussion: 'Diskussion',
    load_more_comments: 'Laden Sie weitere Kommentare',
    comment_confirm_delete:
      'Sind Sie sicher, dass Sie diesen Kommentar löschen möchten?',
    comment_deleted: 'Der Kommentar wurde erfolgreich gelöscht',
  },
  it: {
    language: 'Lingua',

    // Nav
    browse: 'Esplora',
    library: 'Biblioteca',
    account: 'Il mio conto',
    back: 'Torna indietro',
    more: 'Di più',

    // Guides
    guide: 'Guida | Guide',
    views: 'Visualizzazioni',
    table_of_contents: 'Sommario',
    reading_time: 'Momento della lettura',
    date_added: 'Data aggiunta',
    date_updated: 'Data aggiornata',
    minutes_read: 'Minuto letto',
    published: 'Pubblicato',

    // Users
    joined: 'Partecipato',
    last_online: 'Ultimo Online',
    online: 'in linea',
    created: 'creato',
    followers: 'Seguaci',
    partner: 'Compagno',
    profile_hidden: 'Il profilo di questo utente è nascosto',

    // Mods
    mod: 'Mod | Mods',
    level: 'Livello | Livelli',
    content: 'Contenuto',
    subscribed: 'Iscritto',
    tags: 'Tag',
    summary: 'Riepilogo',
    contributors: 'Collaboratori',
    description: 'Descrizione',
    dependencies: 'Dipendenze',
    of: 'di',
    ago: 'fa',
    and: 'E',
    by: 'Di',
    reset_filters: 'Reimposta filtri',
    show_more: 'Mostra di più',
    show_less: 'Mostra meno',
    no_ugc_found: 'Nessun {ugc_name} trovato',
    no_subscriptions: 'Non sei abbonato a nessun {ugc_name}',
    mod_disclaimer_heading: 'Dichiarazione di non responsabilità',
    mod_disclaimer_privacy: 'Informativa sulla privacy',
    thumbs_up_received: 'Pollice in su ricevuto',
    thumbs_up: 'Pollice su',
    total_downloads: 'Download totali',
    releases: 'Rilasci',
    bytes: 'byte',

    // Actions
    login: 'Accedi',
    logout: 'Esci',
    search: 'Cerca',
    clear_all: 'Cancella tutto',
    download: 'Scarica',
    subscribe: 'Iscriviti',
    unsubscribe: "Annulla l'iscrizione",
    resubscribe: "Ripristina l'iscrizione",
    activate: 'Attiva',
    deactivate: 'Disattiva',
    like: 'Mi piace',
    dislike: 'Non mi piace',
    report: 'Segnala un problema',
    submit: 'Invia',
    cancel: 'Annulla',

    // Filters
    all: 'Tutto',
    available: 'disponibili',
    filesize: 'Dimensione file',
    downloads: 'Download',
    todays_downloads: 'I download di oggi',
    subscribers: 'Iscritti',
    rating: 'Valutazione',
    sort_by: 'Ordina per',
    creator: 'Creatore',
    apply: 'Fare domanda a',
    reset: 'Ripristina',
    featured: 'In primo piano',
    toggle_filters: 'Attiva i filtri',
    hidden: 'Nascosto',
    pending: 'In attesa di',
    deleted: 'Eliminato',

    // Login
    signup: 'Accedi o registrati con email',
    login_with: 'Accedi con {service}',
    email_placeholder: 'Indirizzo email',
    code_placeholder: 'Codice a 5 cifre',
    have_code: 'Ho un codice',
    email_code: 'Codice email',
    send_new_code: 'Invia nuovo codice',
    check_email: 'Recuperare il codice nella casella di posta e inserirlo qui.',
    login_disclaimer:
      'I contenuti generati dagli utenti per {game} sono gestiti da mod.io.',
    terms_disclaimer: `Premendo "Accedi", accetti i {studioterms}{terms} e la {privacy} di mod.io e confermi di avere {min_age} anni o più.`,
    terms_disclaimer_studio: '{terms} di {studio}, i ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' e ',
    code_error: 'Impossibile richiedere il codice.',
    or: 'O',

    // Terms
    terms: "Termini d'uso",
    privacy: 'Informativa sulla privacy',
    aup: 'Politica di utilizzo accettabile',
    monetization: 'Termini di monetizzazione',
    game: 'Termini di gioco',
    api: "Termini di accesso all'API",
    effective: 'Efficace da',

    // Report
    report_heading: 'Segnala questa mod',
    report_intro:
      'Segnala un contenuto che viola i {terms} del sito oppure inoltra un {dmca} attraverso il modulo sottostante. Includi tutte le informazioni e i link pertinenti.',
    dmca: 'Reclamo DMCA',
    reason: 'Motivo della segnalazione',
    urls: 'URL della violazione',
    urls_placeholder: 'URL (1 per riga)',
    company_or_name: "Nome proprio o dell'azienda",
    email: 'Email',
    address: 'Indirizzo',
    country: 'Paese',
    country_placeholder: 'Selezionare un Paese',
    details: 'Informazioni sulla violazione',
    details_placeholder:
      "Per facilitare l'elaborazione della segnalazione, inserire più informazioni e prove possibili, inclusi:\n\nURL, date, nomi account rilevanti\nPosizione del contenuto originale\nLa violazione commessa",
    dmca_1:
      "{mod_io} rispetta i diritti di proprietà intellettuale altrui e richiede altrettanto a tutti coloro che utilizzano i suoi siti internet e servizi. Chiunque ritenga che la propria opera sia stata riprodotta in uno dei nostri siti internet o servizi in modo tale da costituire una violazione del copyright, può segnalarlo all'agente designato al DMCA di mod.io attraverso il modulo sottostante.",
    dmca_2:
      'Inoltrare un reclamo per violazione del copyright presenta serie implicazioni giuridiche. Prima di procedere, valutare la possibilità di sporgere reclamo al diretto interessato contattandolo personalmente. Potrebbe trattarsi di un semplice malinteso risolvibile senza il ricorso a provvedimenti legali.',
    dmca_3:
      "Nota bene: secondo il Digital Millennium Copyright Act, Sezione 512 (f), chiunque consapevolmente e sostanzialmente dichiari il falso sulla violazione di un materiale o un'attività, può essere chiamato a rispondere di eventuali danni. Inoltre, le informazioni fornite sotto la presente nota legale potranno essere condivise con terze parti o rese pubbliche.",
    claim_check:
      'Selezionando le seguenti caselle e inviando il presente reclamo, dichiaro SOTTO PENA DI SPERGIURO che',
    copyright_owner: 'Sono il titolare del copyright',
    copyright_auth_owner:
      "Ho l'autorizzazione ad agire per conto del titolare del copyright nelle presenti circostanze.",
    authorization: 'Autorizzazione',
    authorization_check:
      "Ritengo in buona fede che l'utilizzo del materiale segnalato in questo reclamo non sia autorizzato dal titolare del copyright, dal suo agente o dalla legge.",
    acknowledgement: 'Riconoscimento',
    acknowledgement_check:
      "Riconosco che secondo il DMCA, Sezione 512 (f), chiunque consapevolmente e sostanzialmente dichiari il falso sulla violazione di un materiale o un'attività, può essere chiamato a rispondere di eventuali danni.",
    required: 'campo obbligatorio',
    signature: 'Firma',
    signature_placeholder:
      'Digitare nome e cognome nel campo sottostante. Fungerà da firma digitale.',
    report_success_title: 'La segnalazione è stata ricevuta',
    report_success_text:
      'Se il messaggio inviato richiede risposta, si prega di attendere. Ci adoperiamo per rispondere a tutte le segnalazioni entro 48 ore dalla ricezione.',
    report_error_title: 'Impossibile inviare la segnalazione',

    // Table
    name: 'Nome',
    added: 'Periodo pubblicazione',
    updated: 'Aggiornamento',
    file: 'File',
    version: 'Versione',
    actions: 'Azioni',
    locally_installed: 'Installazione locale',

    // Releases
    download_from_game_client: 'Scarica {mod} dal client di gioco',
    release_notes: 'Note di versione',
    no_release_notes: 'Nessuna nota di versione',
    previous_releases: 'Versioni precedenti',
    view_previous_releases: 'Visualizza le versioni precedenti',
    no_previous_releases: 'Nessuna versione precedente',
    no_files_published: 'Nessun file pubblicato',
    download_files_manually: 'Scaricare i file manualmente',
    platforms: 'Piattaforme',

    // Ratings
    overwhelmingly_positive: 'Estremamente positivo',
    overwhelmingly_negative: 'Estremamente negativo',
    very_positive: 'Molto positivo',
    very_negative: 'Molto negativo',
    mostly_positive: 'Prevalentemente positivo',
    mostly_negative: 'Prevalentemente negativo',
    negative: 'Negativo',
    positive: 'Positivo',
    mixed: 'Ambivalente',
    unrated: 'Non classificato',

    // Sort
    sort_comments: 'Commenti',
    sort_total_mods: 'Mod totali',
    sort_trending: 'Di tendenza',
    sort_highest_rated: 'Voto più alto',
    sort_most_popular: 'Più popolare',
    sort_most_subscribers: 'La maggior parte degli abbonati',
    sort_recently_added: 'Aggiunto recentemente',
    sort_last_updated: 'Ultimo aggiornamento',
    sort_alphabetical: 'Alfabetico',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'Non funzionante',
    report_rude_content: 'Contenuti maleducati',
    report_illegal_content: 'Contenuto illegale',
    report_stolen_content: 'Contenuto rubato',
    report_false_information: 'Informazioni false',
    report_other: 'Altro',

    // Errors
    login_fail: 'Impossibile accedere',
    login_fail_message:
      'Impossibile accedere. Per favore aspetta un minuto e riprova.',
    subscribe_fail: 'Impossibile iscriversi',
    unsubscribe_fail: "Impossibile annullare l'iscrizione",

    agreement_not_found: 'Accordo non trovato',
    form_chars_remaining: '{count} personaggi rimanenti.',
    form_not_enough_chars: '{count} più caratteri richiesti.',
    filter: 'Filtro',
    loading: 'Caricamento',
    next_version: 'Versione successiva',
    no_results_found: 'nessun risultato trovato',
    page_not_found: 'Pagina non trovata!',
    previous_version: 'Versione precedente',
    take_me_home: 'Portami a casa',
    validation_alpha_num: 'Il campo può contenere solo numeri o lettere',
    validation_size: 'Il campo deve essere {size} caratteri',
    validation_url: 'Il campo deve essere un URL',
    validation_max: 'Massimi caratteri {max}',
    validation_email: "Il campo deve essere un'e-mail",
    validation_checked: 'Il campo deve essere controllato',
    validation_required: 'Il campo è obbligatiorio',
    validation_name:
      'Il campo può contenere solo lettere e simboli relativi al nome',

    comment: 'commento | commenti',
    team_member: 'Membro della squadra',
    author: 'Autore',
    good_karma: 'Buon karma',
    bad_karma: 'Cattivo karma',
    reply: 'Rispondere',
    replies: 'risposta | risposte',
    save: 'Salva',
    delete: 'Eliminare',
    edit: 'Modificare',
    post: 'Inviare',
    pinned: 'Appuntato',
    locked: 'Bloccato',
    add_comment: 'Aggiungi un commento...',
    comment_login_prompt: 'Accedi per unirti alla discussione!',
    comment_error_add: 'Impossibile aggiungere un commento',
    comment_error_edit: 'Impossibile modificare il commento',
    comment_error_delete: 'Impossibile eliminare il commento',
    comments_error_fetch: 'Impossibile caricare più commenti',
    discussion: 'Discussione',
    load_more_comments: 'Carica più commenti',
    comment_confirm_delete: 'Sei sicuro di voler eliminare questo commento?',
    comment_deleted: 'Il commento è stato eliminato con successo',
  },
  es: {
    language: 'Idioma',

    // Nav
    browse: 'Explorar',
    library: 'Biblioteca',
    account: 'Mi cuenta',
    back: 'Regresa',
    more: 'más',

    // Guides
    guide: 'Guía | Guías',
    views: 'Puntos de vista',
    table_of_contents: 'Tabla de contenido',
    reading_time: 'Tiempo de leer',
    date_added: 'Fecha Agregada',
    date_updated: 'Fecha actualizada',
    minutes_read: 'Lectura de minutos',
    published: 'Publicado',

    // Users
    joined: 'Unido',
    last_online: 'Último en línea',
    online: 'En línea',
    created: 'creado',
    followers: 'Seguidores',
    partner: 'Pareja',
    profile_hidden: 'El perfil de este usuario está oculto',

    // Mods
    mod: 'Mod | Mods',
    level: 'Nivel | Niveles',
    content: 'Contenido',
    subscribed: 'Suscrito',
    tags: 'Etiquetas',
    summary: 'Resumen',
    contributors: 'Contribuciones',
    description: 'Descripción',
    dependencies: 'Dependencias',
    of: 'de',
    ago: 'atrás',
    and: 'y',
    by: 'Por',
    reset_filters: 'Restablecer filtros',
    show_more: 'Mostrar más',
    show_less: 'Mostrar menos',
    no_ugc_found: 'No se encontró {ugc_name}',
    no_subscriptions: 'No te has suscrito a ningún {ugc_name}',
    mod_disclaimer_heading: 'Aviso legal',
    mod_disclaimer_privacy: 'Política de privacidad',
    thumbs_up_received: 'Pulgar arriba recibido',
    thumbs_up: 'Pulgares hacia arriba',
    total_downloads: 'Descargas totales',
    releases: 'Lanzamientos',
    bytes: 'bytes',

    // Actions
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    search: 'Buscar',
    clear_all: 'Borrar todo',
    download: 'Descargar',
    subscribe: 'Suscribirse',
    unsubscribe: 'Anular suscripción',
    resubscribe: 'Volver a suscribirse',
    activate: 'Activar',
    deactivate: 'Desactivar',
    like: 'Me gusta',
    dislike: 'No me gusta',
    report: 'Informar de un problema',
    submit: 'Enviar',
    cancel: 'Cancelar',

    // Filters
    all: 'Todo',
    available: 'disponible(s)',
    filesize: 'Tamaño de archivo',
    downloads: 'Descargas',
    todays_downloads: 'Descargados hoy',
    subscribers: 'Suscriptores',
    rating: 'Valuación',
    sort_by: 'Ordenar por',
    creator: 'Creador',
    apply: 'Aplicar',
    reset: 'Reiniciar',
    featured: 'Presentado',
    toggle_filters: 'Filtros de al revés',
    hidden: 'Oculto',
    pending: 'Pendiente',
    deleted: 'Eliminado',

    // Login
    signup: 'Inicie sesión o regístrese con correo electrónico',
    login_with: 'Iniciar sesión con {service}',
    email_placeholder: 'Dirección de correo electrónico',
    code_placeholder: 'Código de 5 dígitos',
    have_code: 'Tengo un código',
    email_code: 'Enviar código al correo',
    send_new_code: 'Enviar otro código',
    check_email:
      'Busque el correo electrónico con el código e introdúzcalo aquí.',
    login_disclaimer:
      'El contenido generado por el usuario para {game} lo administra mod.io.',
    terms_disclaimer: `Al presionar 'Iniciar sesión', aceptas los {studioterms}{terms} y la {privacy} de mod.io y confirmas que tienes {min_age} años de edad o más.`,
    terms_disclaimer_studio: '{terms} de {studio}, los ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' y ',
    code_error: 'No se ha podido solicitar el código.',
    or: 'o',

    // Terms
    terms: 'Términos de uso',
    privacy: 'Política de privacidad',
    aup: 'Política de uso aceptable',
    monetization: 'Términos de monetización',
    game: 'Términos del juego',
    api: 'Términos de acceso a la API',
    effective: 'Efectivo desde',

    // Report
    report_heading: 'Denunciar este mod',
    report_intro:
      'Denuncie el contenido que no cumpla con los {terms} de esta página o envíe una {dmca} a través de este formulario. Incluya toda la información y enlaces relevantes.',
    dmca: 'queja DMCA',
    reason: 'Motivo de la denuncia',
    urls: 'URL ilícita',
    urls_placeholder: 'URL (1 por línea)',
    company_or_name: 'Empresa o nombre',
    email: 'Correo electrónico',
    address: 'Dirección',
    country: 'País',
    country_placeholder: 'Selecciona un país',
    details: 'Detalles de la infracción',
    details_placeholder:
      'Para que procesemos mejor su denuncia, proporcione toda la información y las pruebas posibles:\n\nURL, fechas, nombre de las cuentas involucradas\ndónde podemos encontrar el material original\nel tipo de infracción que se ha cometido',
    dmca_1:
      '{mod_io} respeta los derechos de propiedad intelectual de todas las personas, por lo que pedimos a quienes hacen uso de nuestros sitios web que también respeten dichos derechos. Cualquier persona que considere que su trabajo se ha replicado en alguno de nuestros sitios web o servicios de manera que constituya un incumplimiento de los derechos de copyright debe notificar al intermediario de derechos copyright de mod.io a través del siguiente formulario.',
    dmca_2:
      'Presentar una reclamación por infracción de los derechos de copyright es un asunto legal grave. Antes de continuar, intente contactar directamente con la persona para remitir directamente su queja. Es posible que se trate de un malentendido y se pueda resolver sin recurrir a un proceso judicial.',
    dmca_3:
      'Tenga en cuenta que, según la sección 512(f) de la Digital Millennium Copyright Act (La Ley de Derechos de Autor de la Era Digital), cualquier persona que informe intencionalmente y sin fundamento acerca de material o actividad ilícita, podrá declararse responsable de los daños. Tenga en cuenta también que la información que proporcione en este aviso legal podrá hacerse pública o compartirse con terceros.',
    claim_check:
      'Al seleccionar las siguientes casillas y enviar esta reclamación declaro BAJO PENA DE PERJURIO que',
    copyright_owner: 'Soy titular de los derechos de Copyright',
    copyright_auth_owner:
      'Tengo autoridad para actuar en nombre del titular de los derechos de copyright en este caso.',
    authorization: 'Autorización',
    authorization_check:
      'Creo de buena fe que el uso del material mencionado en esta reclamación no cuenta con autorización del titular de los derechos de copyright, su representante o la ley.',
    acknowledgement: 'Confirmación',
    acknowledgement_check:
      'Reconozco que, según la sección 512(f) del DMCA, cualquier persona que informe intencionalmente y sin fundamentos de material o actividad ilícito, podrá declararse responsable de los daños.',
    required: 'obligatorio',
    signature: 'Firma',
    signature_placeholder:
      'Escriba su nombre completo en este cuadro como firma digital.',
    report_success_title: 'Hemos recibido su denuncia.',
    report_success_text:
      'Si su mensaje requiere una respuesta, le pedimos que tenga paciencia. Tratamos de responder todas las denuncias en un plazo de 48 horas desde que las recibimos.',
    report_error_title: 'Error al enviar la denuncia',

    // Table
    name: 'Nombre',
    added: 'Añadida',
    updated: 'Actualizada',
    file: 'Archivo',
    version: 'Versión',
    actions: 'Medidas',
    locally_installed: 'Instalado en local',

    // Releases
    download_from_game_client: 'Descargar {mod} desde el cliente del juego',
    release_notes: 'Notas de la versión',
    no_release_notes: 'No se han proporcionado notas de la versión',
    previous_releases: 'Versiones anteriores',
    view_previous_releases: 'Ver lanzamientos anteriores',
    no_previous_releases: 'No hay versiones anteriores',
    no_files_published: 'No se han publicado archivos',
    download_files_manually: 'Descargar archivos manualmente',
    platforms: 'Plataformas',

    // Ratings
    overwhelmingly_positive: 'Extremadamente positivo',
    overwhelmingly_negative: 'Extremadamente negativo',
    very_positive: 'Muy positivo',
    very_negative: 'Muy negativo',
    mostly_positive: 'Generalmente positivo',
    mostly_negative: 'Generalmente negativo',
    negative: 'Negativo',
    positive: 'Positivo',
    mixed: 'Variado',
    unrated: 'Sin clasificar',

    // Sort
    sort_comments: 'Comentarios',
    sort_total_mods: 'Modos totales',
    sort_trending: 'Tendencias',
    sort_highest_rated: 'El mejor valorado',
    sort_most_popular: 'Más popular',
    sort_most_subscribers: 'La mayoría de los suscriptores',
    sort_recently_added: 'Recientemente añadido',
    sort_last_updated: 'Última actualización',
    sort_alphabetical: 'Alfabético',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'No funciona',
    report_rude_content: 'Contenido grosero',
    report_illegal_content: 'Contenido ilegal',
    report_stolen_content: 'Contenido Robado',
    report_false_information: 'Información Falsa',
    report_other: 'Otro',

    // Errors
    login_fail: 'Error al iniciar sesión',
    login_fail_message:
      'Error al iniciar sesión. Espere un minuto y vuelva a intentarlo.',
    subscribe_fail: 'No se suscribió',
    unsubscribe_fail: 'No se puso de baja',

    agreement_not_found: 'Acuerdo no encontrado',
    form_chars_remaining: '{count} caracteres restantes.',
    form_not_enough_chars: '{count} se requieren más caracteres.',
    filter: 'Filtrar',
    loading: 'Cargando',
    next_version: 'Siguiente versión',
    no_results_found: 'No se han encontrado resultados',
    page_not_found: '¡Página no encontrada!',
    previous_version: 'Versión previa',
    take_me_home: 'Llévame a casa',
    validation_alpha_num: 'El campo solo puede contener números o letras',
    validation_size: 'El campo debe ser {size} caracteres',
    validation_url: 'El campo debe ser una URL',
    validation_max: 'Máximo caracteres {max}',
    validation_email: 'El campo debe ser un correo electrónico',
    validation_checked: 'El campo debe ser marcado',
    validation_required: 'Se requiere campo',
    validation_name:
      'El campo solo puede contener letras y símbolos relacionados con el nombre.',

    comment: 'comentario | comentarios',
    team_member: 'Miembro del equipo',
    author: 'Autor',
    good_karma: 'Buen karma',
    bad_karma: 'Karma negativo',
    reply: 'Responder',
    replies: 'responder | respuestas',
    save: 'Ahorrar',
    delete: 'Borrar',
    edit: 'Editar',
    post: 'Correo',
    pinned: 'Fijado',
    locked: 'bloqueado',
    add_comment: 'Añadir un comentario...',
    comment_login_prompt: '¡Inicie sesión para unirse a la discusión!',
    comment_error_add: 'No se pudo agregar comentarios',
    comment_error_edit: 'No se pudo editar comentarios',
    comment_error_delete: 'No se pudo eliminar el comentario',
    comments_error_fetch: 'No se pudo cargar más comentarios',
    discussion: 'Discusión',
    load_more_comments: 'Cargar más comentarios',
    comment_confirm_delete:
      '¿Estás seguro de que quieres eliminar este comentario?',
    comment_deleted: 'El comentario fue eliminado con éxito',
  },
  pl: {
    language: 'Język',

    // Nav
    browse: 'Przeglądaj',
    library: 'Biblioteka',
    account: 'Moje konto',
    back: 'Wróć',
    more: 'więcej',

    // Guides
    guide: 'Przewodnik | Przewodniki',
    views: 'Wyświetlenia',
    table_of_contents: 'Spis treści',
    reading_time: 'Czas czytania',
    date_added: 'Data dodania',
    date_updated: 'Data zaktualizowana',
    minutes_read: 'Minuta czytania',
    published: 'Opublikowany',

    // Users
    joined: 'Dołączył',
    last_online: 'Ostatnio online',
    online: 'online',
    created: 'utworzony',
    followers: 'Obserwujący',
    partner: 'Partner',
    profile_hidden: 'Profil tego użytkownika jest ukryty',

    // Mods
    mod: 'Mod | Mods',
    level: 'Poziom | Poziomy',
    content: 'Zawartość',
    subscribed: 'Subskrybujesz',
    tags: 'Tagi',
    summary: 'Podsumowanie',
    contributors: 'Współtwórcy',
    description: 'Opis',
    dependencies: 'Zależności',
    of: 'z',
    ago: 'temu',
    and: 'I',
    by: 'Przez',
    reset_filters: 'Zresetuj filtry',
    show_more: 'Pokaż więcej',
    show_less: 'Pokaż mniej',
    no_ugc_found: 'Nie znaleziono {ugc_name}',
    no_subscriptions: 'Nie zasubskrybowałeś żadnego {ugc_name}',
    mod_disclaimer_heading: 'Wyłączenie odpowiedzialności',
    mod_disclaimer_privacy: 'Polityce prywatności',
    thumbs_up_received: 'Kciuki w górę odebrane',
    thumbs_up: 'Kciuki w górę',
    total_downloads: 'Całkowita liczba pobrań',
    releases: 'Wydania',
    bytes: 'bajty',

    // Actions
    login: 'Zaloguj',
    logout: 'Wyloguj',
    search: 'Szukaj',
    clear_all: 'Wyczyść wszystko',
    download: 'Pobierz',
    subscribe: 'Subskrybuj',
    unsubscribe: 'Anuluj subskrypcję',
    resubscribe: 'Subskrybuj ponownie',
    activate: 'Aktywuj',
    deactivate: 'Dezaktywuj',
    like: 'Lubię',
    dislike: 'Nie lubię',
    report: 'Zgłoś problem',
    submit: 'Prześlij',
    cancel: 'Anuluj',

    // Filters
    all: 'Wszystko',
    available: 'dostępne(-ych)',
    filesize: 'Rozmiar pliku',
    downloads: 'Liczba pobrań',
    todays_downloads: 'Pobrania dziś',
    subscribers: 'Subskrybenci',
    rating: 'Ocena',
    sort_by: 'Sortuj według',
    creator: 'Twórca',
    apply: 'Stosować',
    reset: 'Resetowanie',
    featured: 'Wyróżniony',
    toggle_filters: 'Przełącz filtry',
    hidden: 'Ukryty',
    pending: 'Aż do',
    deleted: 'Usunięto',

    // Login
    signup: 'Zaloguj się lub zarejestruj za pomocą adresu e-mail',
    login_with: 'Zaloguj się za pomocą {service}',
    email_placeholder: 'Adres e-mail',
    code_placeholder: '5-cyfrowy kod',
    have_code: 'Mam kod.',
    email_code: 'Wyślij kod',
    send_new_code: 'Wyślij nowy kod',
    check_email: 'Sprawdź pocztę i wprowadź otrzymany kod tutaj.',
    login_disclaimer:
      'Treściami gry {game} generowanymi przez użytkowników zarządza mod.io.',
    terms_disclaimer: `Naciskając „Zaloguj się”, wyrażasz zgodę na {studioterms}{terms} i {privacy} mod.io i potwierdzasz, że masz ukończone {min_age} lat.`,
    terms_disclaimer_studio: '{terms} {studio}, ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' i ',
    code_error: 'Nie można poprosić o kod.',
    or: 'Lub',

    // Terms
    terms: 'Warunki korzystania',
    privacy: 'Polityka prywatności',
    aup: 'Zasady dopuszczalnego użytkowania',
    monetization: 'Warunki monetyzacji',
    game: 'Warunki gry',
    api: 'Warunki dostępu do API',
    effective: 'Obowiązuje od',

    // Report
    report_heading: 'Zgłoś tego moda',
    report_intro:
      'Zgłoś treść naruszającą {terms} witryny lub prześlij {dmca} za pomocą poniższego formularza. Pamiętaj, by zawrzeć w nim wszystkie istotne informacje i linki.',
    dmca: 'zgłoszenie dotyczące naruszenia ustawy DMCA',
    reason: 'Powód zgłoszenia',
    urls: 'Obraźliwe adresy URL',
    urls_placeholder: 'Adresy URL (po jednym na wiersz)',
    company_or_name: 'Nazwa firmy lub Twoje imię i nazwisko',
    email: 'Adres e-mail',
    address: 'Adres',
    country: 'Kraj',
    country_placeholder: 'Wybierz kraj',
    details: 'Szczegóły naruszenia',
    details_placeholder:
      'Aby pomóc nam rozpatrzyć zgłoszenie, podaj jak najwięcej szczegółów i dowodów, w tym:\n\nadresy URL, daty i nazw kont, których dotyczy zgłoszenie;\nmiejsce, w którym można znaleźć oryginalną zawartość;\nnaruszenie, do którego doszło.',
    dmca_1:
      'Zespół {mod_io} szanuje prawa własności intelektualnej innych osób i prosimy wszystkich korzystających z naszych stron internetowych i usług o to samo. Każdy, kto uważa, że jego praca została powielona na jednej z naszych stron internetowych lub w jednej z usług w sposób stanowiący naruszenie praw autorskich, może powiadomić przedstawiciela ds. praw autorskich mod.io, korzystając z poniższego formularza.',
    dmca_2:
      'Zgłoszenie roszczenia dotyczącego naruszenia praw autorskich to poważna kwestia prawna. Zanim przejdziesz dalej, możesz rozważyć bezpośredni kontakt z daną osobą w celu złożenia skargi. To może być zwykłe nieporozumienie, które można rozwiązać bez angażowania się w faktyczny proces prawny.',
    dmca_3:
      'Pamiętaj, że zgodnie z sekcją 512(f) amerykańskiej ustawy Digital Millennium Copyright Act każda osoba, która świadomie wprowadza innych w błąd, twierdząc, że materiał lub działanie narusza prawa autorskie, może zostać pociągnięta do odpowiedzialności za wynikłe szkody. Pamiętaj też, że informacje zawarte w niniejszej nocie prawnej mogą być udostępniane stronom trzecim lub upubliczniane.',
    claim_check:
      'Zaznaczając poniższe pola i przesyłając niniejsze roszczenie, oświadczam POD KARĄ ZA SKŁADANIE FAŁSZYWYCH ZEZNIAŃ, co następuje:',
    copyright_owner: 'Jestem właścicielem(-ką) praw autorskich.',
    copyright_auth_owner:
      'Mam upoważnienie do działania w imieniu właściciela(-ki) praw autorskich w takiej sytuacji.',
    authorization: 'Upoważnienie',
    authorization_check:
      'W dobrej wierze wyrażam przekonanie, że wykorzystanie materiału wymienionego w tym roszczeniu nie zostało autoryzowane przez właściciela(-kę) praw autorskich, jego/jej przedstawiciela(-kę) lub nie jest zgodne z prawem.',
    acknowledgement: 'Potwierdzenie',
    acknowledgement_check:
      'Przyjmuję do wiadomości, że zgodnie z sekcją 512(f) amerykańskiej ustawy Digital Millennium Copyright Act każda osoba, która świadomie wprowadza innych w błąd, twierdząc, że materiał lub działanie narusza prawa autorskie, może zostać pociągnięta do odpowiedzialności za wynikłe szkody.',
    required: 'wymagane',
    signature: 'Podpis',
    signature_placeholder:
      'Wpisz imię i nazwisko w tym polu – będzie równoznaczne z Twoim podpisem cyfrowym.',
    report_success_title: 'Otrzymaliśmy Twoje zgłoszenie',
    report_success_text:
      'Jeśli Twoja wiadomość wymaga odpowiedzi, prosimy o cierpliwość, ponieważ staramy się odpowiadać na wszystkie zgłoszenia w ciągu 48 godzin od ich otrzymania.',
    report_error_title: 'Nie udało się przesłać zgłoszenia',

    // Table
    name: 'Nazwa',
    added: 'Dodano',
    updated: 'Zaktualizowano',
    file: 'Plik',
    version: 'Wersja',
    actions: 'Działania',
    locally_installed: 'Zainstalowane lokalnie',

    // Releases
    download_from_game_client: 'Pobierz moda {mod} z klienta gry',
    release_notes: 'Informacje o wydaniu',
    no_release_notes: 'Brak informacji o wydaniu',
    previous_releases: 'Poprzednie wydania',
    view_previous_releases: 'Zobacz poprzednie wydania',
    no_previous_releases: 'Nie ma poprzednich wydań.',
    no_files_published: 'Brak opublikowanych plików',
    download_files_manually: 'Pobierz pliki ręcznie',
    platforms: 'Platformy',

    // Ratings
    overwhelmingly_positive: 'Przytłaczająco pozytywne',
    overwhelmingly_negative: 'Przytłaczająco negatywne',
    very_positive: 'Bardzo pozytywne',
    very_negative: 'Bardzo negatywne',
    mostly_positive: 'Głównie pozytywne',
    mostly_negative: 'Głównie negatywne',
    negative: 'Negatywne',
    positive: 'Pozytywne',
    mixed: 'Mieszane',
    unrated: 'Brak ocen',

    // Sort
    sort_comments: 'Uwagi',
    sort_total_mods: 'Wszystkie mody',
    sort_trending: 'Popularne',
    sort_highest_rated: 'Najwyżej oceniany',
    sort_most_popular: 'Najbardziej popularny',
    sort_most_subscribers: 'Większość abonentów',
    sort_recently_added: 'Niedawno dodane',
    sort_last_updated: 'Ostatnio zaktualizowany',
    sort_alphabetical: 'Alfabetyczny',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: 'Nie działa',
    report_rude_content: 'Niegrzeczna treść',
    report_illegal_content: 'Nielegalna treść',
    report_stolen_content: 'Skradziona zawartość',
    report_false_information: 'Fałszywe informacje',
    report_other: 'Inne',

    // Errors
    login_fail: 'Nie udało się zalogować',
    login_fail_message:
      'Nie udało się zalogować. Poczekaj chwilę i spróbuj ponownie.',
    subscribe_fail: 'Nie udało się zasubskrybować',
    unsubscribe_fail: 'Nie udało się zrezygnować z subskrypcji',

    agreement_not_found: 'Umowa nie została znaleziona',
    form_chars_remaining: '{count} pozostałe znaki.',
    form_not_enough_chars: '{count} Wymagane więcej znaków.',
    filter: 'Filtr',
    loading: 'Ładowanie',
    next_version: 'Następna wersja',
    no_results_found: 'Nie znaleziono wyników',
    page_not_found: 'Strona nie znaleziona!',
    previous_version: 'Poprzednia wersja',
    take_me_home: 'Zabierz mnie do domu',
    validation_alpha_num: 'Pole może zawierać tylko liczby lub litery',
    validation_size: 'Pole musi być znakami {size}',
    validation_url: 'Pole musi być adresem URL',
    validation_max: 'Maksymalne znaki {max}',
    validation_email: 'Pole musi być e -mailem',
    validation_checked: 'Pole musi być sprawdzone',
    validation_required: 'To pole jest wymagane',
    validation_name:
      'Pole może zawierać wyłącznie litery i symbole związane z nazwą',

    comment: 'komentarz | komentarze',
    team_member: 'Członek zespołu',
    author: 'Autor',
    good_karma: 'Dobra Karma',
    bad_karma: 'Zła karma',
    reply: 'Odpowiedź',
    replies: 'odpowiedź | odpowiedzi',
    save: 'Ratować',
    delete: 'Usuwać',
    edit: 'Edytować',
    post: 'Post',
    pinned: 'Przypięty',
    locked: 'Zablokowany',
    add_comment: 'Dodaj komentarz...',
    comment_login_prompt: 'Zaloguj się, aby dołączyć do dyskusji!',
    comment_error_add: 'Nie udało się dodać komentarza',
    comment_error_edit: 'Nie udało się edytować komentarza',
    comment_error_delete: 'Nie udało się usunąć komentarza',
    comments_error_fetch: 'Nie udało się załadować więcej komentarzy',
    discussion: 'Dyskusja',
    load_more_comments: 'Załaduj więcej komentarzy',
    comment_confirm_delete: 'Czy na pewno chcesz usunąć ten komentarz?',
    comment_deleted: 'Komentarz został pomyślnie usunięty',
  },
  ja: {
    language: '言語',

    // Nav
    browse: '閲覧',
    library: '図書館',
    account: '私のアカウント',
    back: '戻る',
    more: 'もっと',

    // Guides
    guide: 'ガイド |ガイド',
    views: 'ビュー',
    table_of_contents: '目次',
    reading_time: '読書の時間',
    date_added: '追加日',
    date_updated: '更新日',
    minutes_read: '分読み',
    published: '発行済み',

    // Users
    joined: '参加しました',
    last_online: 'ラストオンライン',
    online: 'オンライン',
    created: '作成した',
    followers: 'フォロワー',
    partner: '相棒',
    profile_hidden: 'このユーザーのプロフィールは非表示です',

    // Mods
    mod: 'Mod | Mods',
    level: 'レベル |レベル',
    content: 'コンテンツ',
    subscribed: '購読中',
    tags: 'タグ',
    summary: '概要',
    contributors: '貢献者',
    description: '説明',
    dependencies: '依存関係',
    of: '/',
    ago: '前',
    and: 'そして',
    by: 'による',
    reset_filters: 'フィルターをリセット',
    show_more: 'もっと見せる',
    show_less: '表示を減らす',
    no_ugc_found: '{ugc_name} は見つかりませんでした',
    no_subscriptions: 'どの {ugc_name} も購読していません',
    mod_disclaimer_heading: '法的免責事項',
    mod_disclaimer_privacy: 'プライバシーポリシー',
    thumbs_up_received: '親指を受け取りました',
    thumbs_up: 'いいぞ',
    total_downloads: '総ダウンロード数',
    releases: 'リリース',
    bytes: 'バイト',

    // Actions
    login: 'ログイン',
    logout: 'ログアウト',
    search: '検索',
    clear_all: 'すべてクリア',
    download: 'ダウンロード',
    subscribe: '購読',
    unsubscribe: '購読解除',
    resubscribe: '再講読',
    activate: '有効化',
    deactivate: '無効化',
    like: 'いいね',
    dislike: '気に入らない',
    report: '問題を報告します',
    submit: '送信',
    cancel: 'キャンセル',

    // Filters
    all: 'すべて',
    available: '利用可能',
    filesize: 'ファイルサイズ',
    downloads: 'ダウンロード数',
    todays_downloads: '今日のダウンロード数',
    subscribers: '購読ユーザー',
    rating: '評価',
    sort_by: '並べ替え',
    creator: 'クリエイター',
    apply: '適用する',
    reset: 'リセット',
    featured: '特徴',
    toggle_filters: 'フィルターを切り替えます',
    hidden: '隠れた',
    pending: '保留中',
    deleted: '削除されました',

    // Login
    signup: 'ログインまたはメールアドレスで登録',
    login_with: '{service}でログインします',
    email_placeholder: 'メールアドレス',
    code_placeholder: '5 桁のコード',
    have_code: 'コードを持っています',
    email_code: 'コードをメール送信',
    send_new_code: '新しいコードを送信',
    check_email: 'メールに記載されたコードを確認し、ここに入力してください。',
    login_disclaimer:
      '{game} のユーザー生成コンテンツは mod.io によって管理されています。',
    terms_disclaimer: `「ログイン」を押すと{studioterms}、mod.io の {terms} と {privacy} に同意し、{min_age} 歳以上であることを確認したことになります。`,
    terms_disclaimer_studio: '、{studio} の {terms}',
    terms_disclaimer_studio_separator: '、',
    terms_disclaimer_studio_and: ' と ',
    code_error: 'コードをリクエストできません。',
    or: 'または',

    // Terms
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
    aup: '利用規約',
    monetization: '収益化条件',
    game: 'ゲーム規約',
    api: 'APIアクセス規約',
    effective: 'から有効',

    // Report
    report_heading: 'この mod を報告する',
    report_intro:
      '以下のフォームを使用してサイトの{terms}に違反するコンテンツを報告するか、{dmca}を送信してください。関連するすべての情報とリンクを必ず含めてください。',
    dmca: 'DMCA に関わる苦情',
    reason: '報告理由',
    urls: '違反のある URL',
    urls_placeholder: 'URL（1 行ずつ）',
    company_or_name: '会社またはあなたの名前',
    email: 'メール',
    address: 'アドレス',
    country: '国',
    country_placeholder: '国を選択してください',
    details: '侵害・違反の詳細',
    details_placeholder:
      '報告の処理に役立てるため、できる限り詳細な情報と証拠をご提供ください:\n\nURL、日付、関係のあるアカウント名\n元のコンテンツの場所\n発生した侵害・違反の内容',
    dmca_1:
      '{mod_io} は他者の知的財産権を尊重しており、当社のネットサイトとサービスをご利用のすべての方にも同様のことを求めています。当社のいずれかのネットサイトまたはサービスにおいて、著作権侵害にあたる何らかの方法で自分の作品が複製されていると思われる場合は、以下のフォームを使用して mod.io の著作権代理人に通知することができます。',
    dmca_2:
      '著作権侵害の申し立てを提出することは、重大な法的事項です。続行する前に、直接個人に連絡し、申し立ての内容に対処することを検討してください。適切な法的手続きをとらずとも対処できる単純な誤解である可能性もあります。',
    dmca_3:
      'デジタルミレニアム著作権法第 512 条(f) に基づき、作品または活動が侵害しているとして、故意に重大な虚偽を訴える者は、損害賠償責任を負う可能可能性があることに注意してください。また、この法的通知で提供される情報は第三者と共有されたり、公開されたりする可能性があることにも注意してください。',
    claim_check:
      '以下のチェックボックスをオンにしてこの申し立てを提出することにより、私は、偽証罪の罰則付きにより、以下のことを表明します。',
    copyright_owner: '私は著作権所有者です。',
    copyright_auth_owner:
      '私は、この状況において、著作権所有者に代わって行動する権限を有しています。',
    authorization: '許可',
    authorization_check:
      '私は、この申し立てに記載されている作品の使用が著作権所有者、その代理人、または法によって許可されていないと確信しています。',
    acknowledgement: '同意',
    acknowledgement_check:
      '私は、DMCA の第 512 条(f) に基づき、作品または活動が侵害しているとして故意に重大な虚偽を訴えた者は、損害賠償責任を負う可能性があることを認めます。',
    required: '必須',
    signature: '署名',
    signature_placeholder:
      'このボックスにデジタル署名として機能する氏名を入力してください。',
    report_success_title: 'あなたの報告を受領いたしました。',
    report_success_text:
      'あなたのメッセージに返信が必要な場合は、報告を受けてから 48 時間以内にすべての報告者に返信するように努めておりますので、しばらくお待ちください。',
    report_error_title: '報告を提出できませんでした',

    // Table
    name: '名前',
    added: '追加',
    updated: '更新',
    file: 'ファイル',
    version: 'バージョン',
    actions: 'アクション',
    locally_installed: 'ローカルにインストール済み',

    // Releases
    download_from_game_client: 'ゲームクライアントから {mod} をダウンロード',
    release_notes: 'リリースノート',
    no_release_notes: 'リリースノートはありません',
    previous_releases: '以前のリリース',
    view_previous_releases: '以前のリリースを表示する',
    no_previous_releases: '以前のリリースはありません',
    no_files_published: 'ファイルは公開されていません',
    download_files_manually: 'ファイルを手動でダウンロードする',
    platforms: 'プラットフォーム',

    // Ratings
    overwhelmingly_positive: '圧倒的にポジティブ',
    overwhelmingly_negative: '圧倒的にネガティブ',
    very_positive: '非常にポジティブ',
    very_negative: '非常にネガティブ',
    mostly_positive: 'ほとんどがポジティブ',
    mostly_negative: 'ほとんどがネガティブ',
    negative: 'ネガティブ',
    positive: 'ポジティブ',
    mixed: 'どちらでもない',
    unrated: '未評価',

    // Sort
    sort_comments: 'コメント',
    sort_total_mods: '総改造数',
    sort_trending: 'トレンド',
    sort_highest_rated: '最高評価',
    sort_most_popular: '最も人気のある',
    sort_most_subscribers: 'ほとんどの購読者',
    sort_recently_added: '最近追加された',
    sort_last_updated: '最終更新',
    sort_alphabetical: 'アルファベット順',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: '動作していません',
    report_rude_content: '失礼なコンテンツ',
    report_illegal_content: '違法なコンテンツ',
    report_stolen_content: '盗まれたコンテンツ',
    report_false_information: '虚偽の情報',
    report_other: 'その他',

    // Errors
    login_fail: 'ログインに失敗しました',
    login_fail_message:
      'ログインに失敗しました。ちょっと待って、もう一度やり直してください。',
    subscribe_fail: '購読に失敗しました',
    unsubscribe_fail: '登録解除に失敗しました',

    agreement_not_found: '合意が見つかりません',
    form_chars_remaining: '{count}文字が残っています。',
    form_not_enough_chars: '{count}より多くの文字が必要です。',
    filter: 'フィルター',
    loading: '読み込み',
    next_version: '次のバージョン',
    no_results_found: '結果が見つかりません',
    page_not_found: 'ページが見つかりません！',
    previous_version: '前のバージョン',
    take_me_home: '家まで連れて帰ってください',
    validation_alpha_num:
      'フィールドには数字または文字のみを含めることができます',
    validation_size: 'フィールドは{size}文字でなければなりません',
    validation_url: 'フィールドはURLでなければなりません',
    validation_max: '最大{max}文字 {max}',
    validation_email: 'フィールドは電子メールでなければなりません',
    validation_checked: 'フィールドを確認する必要があります',
    validation_required: 'フィールドは必須項目です',
    validation_name:
      'フィールドには文字と名前関連の記号のみを含めることができます',

    comment: 'コメント',
    team_member: 'チームメンバー',
    author: '著者',
    good_karma: '良いカルマ',
    bad_karma: '悪いカルマ',
    reply: '返事',
    replies: '返信 |返信する',
    save: '保存',
    delete: '消去',
    edit: '編集',
    post: '役職',
    pinned: 'ピン留め',
    locked: 'ロックされています',
    add_comment: 'コメントを追加...',
    comment_login_prompt: 'ログインしてディスカッションに参加してください！',
    comment_error_add: 'コメントを追加できませんでした',
    comment_error_edit: 'コメントの編集に失敗しました',
    comment_error_delete: 'コメントを削除できませんでした',
    comments_error_fetch: 'より多くのコメントをロードできませんでした',
    discussion: '議論',
    load_more_comments: 'より多くのコメントを読み込みます',
    comment_confirm_delete: 'このコメントを削除したいですか？',
    comment_deleted: 'コメントは正常に削除されました',
  },
  ko: {
    language: '언어',

    // Nav
    browse: '탐색',
    library: '도서관',
    account: '내 계정',
    back: '돌아 가라',
    more: '더',

    // Guides
    guide: '가이드 | 가이드',
    views: '견해',
    table_of_contents: '목차',
    reading_time: '독서 시간',
    date_added: '추가된 날짜',
    date_updated: '업데이트된 날짜',
    minutes_read: '분 읽기',
    published: '게시됨',

    // Users
    joined: '가입됨',
    last_online: '마지막 온라인',
    online: '온라인',
    created: '만들어진',
    followers: '추종자',
    partner: '파트너',
    profile_hidden: '이 사용자의 프로필은 숨겨져 있습니다',

    // Mods
    mod: 'Mod | Mods',
    level: '레벨 | 레벨',
    content: '콘텐츠',
    subscribed: '구독',
    tags: '태그',
    summary: '요약',
    contributors: '기여자',
    description: '설명',
    dependencies: '종속성',
    of: '/',
    ago: '~ 전에',
    and: '그리고',
    by: '에 의해',
    reset_filters: '필터 재설정',
    show_more: '자세히보기',
    show_less: '간략히 표시',
    no_ugc_found: '{ugc_name}을(를) 찾을 수 없음',
    no_subscriptions: '{ugc_name}을(를) 구독하지 않았습니다.',
    mod_disclaimer_heading: '법적 면책 조항',
    mod_disclaimer_privacy: '개인정보보호방침을 참조해 주세요',
    thumbs_up_received: '좋아요를 받았습니다.',
    thumbs_up: '엄지손가락',
    total_downloads: '총 다운로드',
    releases: '릴리스',
    bytes: '바이트',

    // Actions
    login: '로그인',
    logout: '로그 아웃',
    search: '검색',
    clear_all: '모두 지우기',
    download: '다운로드',
    subscribe: '구독',
    unsubscribe: '구독 취소',
    resubscribe: '재구독',
    activate: '활성화',
    deactivate: '비활성화',
    like: '좋아요',
    dislike: '싫어요',
    report: '문제 신고',
    submit: '제출',
    cancel: '취소',

    // Filters
    all: '모두',
    available: '사용 가능',
    filesize: '파일 크기',
    downloads: '다운로드',
    todays_downloads: '오늘의 다운로드',
    subscribers: '가입자',
    rating: '평가',
    sort_by: '정렬 기준',
    creator: '생성자',
    apply: '적용하다',
    reset: '초기화',
    featured: '추천',
    toggle_filters: '전환 필터',
    hidden: '숨겨진',
    pending: '보류 중',
    deleted: '삭제됨',

    // Login
    signup: '이메일로 로그인 또는 가입',
    login_with: '{service}로 로그인',
    email_placeholder: '이메일 주소',
    code_placeholder: '5자리 코드',
    have_code: '코드가 있습니다',
    email_code: '이메일 코드',
    send_new_code: '새 코드 보내기',
    check_email: '이메일에서 코드를 확인하고 여기에 입력하세요.',
    login_disclaimer: '{game}의 사용자 생성 콘텐츠는 mod.io에서 관리합니다.',
    terms_disclaimer: `"로그인"을 누르면 {studioterms}mod.io의 {terms} 및 {privacy}에 동의하고 {min_age}세 이상임을 확인하게 됩니다.`,
    terms_disclaimer_studio: '{studio}의 {terms}, ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' 및 ',
    code_error: '코드를 요청할 수 없습니다.',
    or: '또는',

    // Terms
    terms: '이용 약관',
    privacy: '개인정보 보호 정책',
    aup: '허용되는 사용 정책',
    monetization: '수익 창출 조건',
    game: '게임 용어',
    api: 'API 액세스 약관',
    effective: '부터 발효',

    // Report
    report_heading: '이 Mod 신고',
    report_intro:
      '사이트의 {terms} 위반하는 콘텐츠를 신고하거나 아래 양식을 사용하여 {dmca}를 제출하십시오. 모든 관련 정보와 링크를 포함했는지 확인하십시오.',
    dmca: 'DMCA 불만 제기',
    reason: '신고 이유',
    urls: '잘못된 URL',
    urls_placeholder: 'URL(한 줄에 1개)',
    company_or_name: '회사 또는 귀하의 이름',
    email: '이메일',
    address: '주소',
    country: '국가',
    country_placeholder: '국가를 선택하세요',
    details: '위반 사항 세부 정보',
    details_placeholder:
      '신고를 처리하는 데 도움이 되도록 URL, 날짜, 관련된 계정 이름\n\n원본 콘텐츠를 찾을 수 있는 위치\n발생한 위반 사항을 포함하여\n가능한 한 많은 세부 정보와 증거를 제공하십시오.',
    dmca_1:
      '{mod_io}는 타인의 지적 재산권을 존중하며 당사 인터넷 사이트 및 서비스를 사용하는 모든 사람이 동일하게 행동할 것을 요청합니다. 자신의 작품이 저작권을 침해하는 방식으로 당사의 인터넷 사이트 또는 서비스 중 하나에 복제되었다고 생각하는 사람은 아래 양식을 사용하여 mod.io의 저작권 대리인에게 알릴 수 있습니다.',
    dmca_2:
      '저작권 침해 주장을 제출하는 것은 심각한 법적 문제입니다. 진행하기 전에 개인에게 직접 연락하여 불만 사항을 처리하는 것을 고려할 수 있습니다. 단순한 오해일 수 있으며 적절한 법적 절차를 거치지 않고 해결할 수 있습니다.',
    dmca_3:
      '디지털 밀레니엄 저작권법(Digital Millennium Copyright Act) 512(f)절에 따라 자료나 활동이 저작권을 침해한다고 고의적으로 실질적으로 허위 진술하는 사람은 손해 배상 책임을 질 수 있습니다. 또한 이 법적 고지에 제공된 정보는 제3자와 공유되거나 공개될 수 있습니다.',
    claim_check:
      '다음 확인란을 선택하고 이러한 불만 사항을 제출함으로써 본인은 위증 시 처벌을 받는다는 조건 하에 다음과 같이 진술합니다.',
    copyright_owner: '본인은 저작권 소유자입니다',
    copyright_auth_owner:
      '본인은 이 상황에서 저작권 소유자를 대신하여 행동할 권한이 있습니다.',
    authorization: '권한 부여',
    authorization_check:
      '본인은 이 불만 사항에 언급된 자료의 사용이 저작권 소유자, 그 대리인 또는 법률에 의해 승인되지 않았음을 선의로 믿습니다.',
    acknowledgement: '인정',
    acknowledgement_check:
      '본인은 DMCA 512(f)절에 따라 자료나 활동이 저작권을 침해한다고 고의적으로 실질적으로 허위 진술하는 사람은 손해 배상 책임을 질 수 있음을 인정합니다.',
    required: '필수',
    signature: '서명',
    signature_placeholder:
      '디지털 서명 역할을 하는 성명을 이 확인란에 입력하십시오.',
    report_success_title: '귀하의 신고가 접수되었습니다',
    report_success_text:
      '귀하의 메시지에 대한 답변이 필요한 경우 모든 보고서를 받은 후 48시간 이내에 답변하기 위해 최선을 다하고 있으니 조금만 기다려 주십시오.',
    report_error_title: '보고서를 제출하지 못했습니다',

    // Table
    name: '이름',
    added: '추가됨',
    updated: '업데이트됨',
    file: '파일',
    version: '버전',
    actions: '행동',
    locally_installed: '로컬로 설치됨',

    // Releases
    download_from_game_client: '게임 클라이언트에서 {mod} 다운로드',
    release_notes: '릴리즈 노트',
    no_release_notes: '릴리스 노트가 제공되지 않음',
    previous_releases: '이전 릴리스',
    view_previous_releases: '이전 릴리스 보기',
    no_previous_releases: '이전 릴리스가 없습니다',
    no_files_published: '게시된 파일 없음',
    download_files_manually: '수동으로 파일 다운로드',
    platforms: '플랫폼',

    // Ratings
    overwhelmingly_positive: '압도적으로 긍정적',
    overwhelmingly_negative: '압도적으로 부정적',
    very_positive: '매우 긍정적',
    very_negative: '매우 부정적',
    mostly_positive: '대부분 긍정적',
    mostly_negative: '대부분 부정적',
    negative: '부정적',
    positive: '긍정적',
    mixed: '혼합',
    unrated: '등급 평가 없음',

    // Sort
    sort_comments: '코멘트',
    sort_total_mods: '총 모드',
    sort_trending: '트렌드',
    sort_highest_rated: '최고 평점',
    sort_most_popular: '가장 인기 많은',
    sort_most_subscribers: '대부분의 가입자',
    sort_recently_added: '최근에 추가',
    sort_last_updated: '마지막 업데이트',
    sort_alphabetical: '알파벳순',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: '작동하지 않음',
    report_rude_content: '무례한 콘텐츠',
    report_illegal_content: '불법 콘텐츠',
    report_stolen_content: '훔친 콘텐츠',
    report_false_information: '거짓 정보',
    report_other: '기타',

    // Errors
    login_fail: '로그인 실패',
    login_fail_message: '로그인 실패. 잠시만 기다려 다시 시도하십시오.',
    subscribe_fail: '구독하지 못했습니다',
    unsubscribe_fail: '구독 취소 실패',

    agreement_not_found: '계약을 찾을 수 없습니다',
    form_chars_remaining: '{count} 남은 문자.',
    form_not_enough_chars: '{count} 더 많은 문자가 필요합니다.',
    filter: '필터',
    loading: '로딩',
    next_version: '다음 버전',
    no_results_found: '검색 결과가 없습니다',
    page_not_found: '페이지를 찾을 수 없습니다!',
    previous_version: '이전 버전',
    take_me_home: '나를 집에 데려가',
    validation_alpha_num: '필드에는 숫자 나 글자 만 포함 할 수 있습니다',
    validation_size: '필드는 {size} 문자 여야합니다',
    validation_url: '필드는 URL이어야합니다',
    validation_max: '최대 {max} 문자',
    validation_email: '필드는 이메일이어야합니다',
    validation_checked: '필드를 점검해야합니다',
    validation_required: '필드가 필요합니다',
    validation_name: '필드에는 문자 및 이름 관련 기호만 포함될 수 있습니다.',

    comment: '논평',
    team_member: '팀 구성원',
    author: '작가',
    good_karma: '좋은 카르마',
    bad_karma: '나쁜 카르마',
    reply: '회신하다',
    replies: '답장 | 답글',
    save: '구하다',
    delete: '삭제',
    edit: '편집하다',
    post: '우편',
    pinned: '고정됨',
    locked: '잠김',
    add_comment: '의견을 추가하다...',
    comment_login_prompt: '토론에 참여하려면 로그인하십시오!',
    comment_error_add: '댓글을 추가하지 못했습니다',
    comment_error_edit: '주석을 편집하지 못했습니다',
    comment_error_delete: '주석을 삭제하지 못했습니다',
    comments_error_fetch: '더 많은 댓글을로드하지 못했습니다',
    discussion: '논의',
    load_more_comments: '더 많은 의견을로드하십시오',
    comment_confirm_delete: '이 의견을 삭제 하시겠습니까?',
    comment_deleted: '의견이 성공적으로 삭제되었습니다',
  },
  ru: {
    language: 'Язык',

    // Nav
    browse: 'Просмотр',
    library: 'Библиотека',
    account: 'Мой счет',
    back: 'Возвращаться',
    more: 'более',

    // Guides
    guide: 'Путеводитель | Путеводители',
    views: 'Взгляды',
    table_of_contents: 'Оглавление',
    reading_time: 'Время чтения',
    date_added: 'Дата Добавлена',
    date_updated: 'Дата обновления',
    minutes_read: 'Минута чтения',
    published: 'Опубликовано',

    // Users
    joined: 'Присоединился',
    last_online: 'Последний раз в сети',
    online: 'В сети',
    created: 'Созданный',
    followers: 'Последователи',
    partner: 'Партнер',
    profile_hidden: 'Профиль этого пользователя скрыт',

    // Mods
    mod: 'Mod | Mods',
    level: 'Уровень | Уровни',
    content: 'Содержимое',
    subscribed: 'В подписках',
    tags: 'Теги',
    summary: 'Сведения',
    contributors: 'Участники',
    description: 'Описание',
    dependencies: 'Зависимости',
    of: 'из',
    ago: 'назад',
    and: 'и',
    by: 'К',
    reset_filters: 'Сбросить фильтры',
    show_more: 'Показать больше',
    show_less: 'Показать меньше',
    no_ugc_found: '{ugc_name} не найдено',
    no_subscriptions: 'Вы не подписаны ни на один {ugc_name}',
    mod_disclaimer_heading: 'Заявление об отказе от ответственности',
    mod_disclaimer_privacy: 'Положением об использовании персональных данных',
    thumbs_up_received: 'Оценка "Нравится" получена',
    thumbs_up: 'Недурно',
    total_downloads: 'Всего загрузок',
    releases: 'Релизы',
    bytes: 'байты',

    // Actions
    login: 'Вход',
    logout: 'Выйти',
    search: 'Поиск',
    clear_all: 'Очистить все',
    download: 'Загрузить',
    subscribe: 'Подписаться',
    unsubscribe: 'Отписаться',
    resubscribe: 'Подписаться снова',
    activate: 'Активировать',
    deactivate: 'Деактивировать',
    like: 'Нравится',
    dislike: 'Не нравится',
    report: 'Сообщить о проблеме',
    submit: 'Отправить',
    cancel: 'Отмена',

    // Filters
    all: 'Все',
    available: 'для загрузки',
    filesize: 'Размер файла',
    downloads: 'Загрузок',
    todays_downloads: 'Загрузок сегодня',
    subscribers: 'Подписчиков',
    rating: 'Рейтинг',
    sort_by: 'Сортировать по',
    creator: 'Создатель',
    apply: 'Применять',
    reset: 'Перезагрузить',
    featured: 'Показан',
    toggle_filters: 'Переверните фильтры',
    hidden: 'Скрытый',
    pending: 'В ожидании',
    deleted: 'Удалено',

    // Login
    signup: 'Войдите или зарегистрируйтесь с помощью эл. почты',
    login_with: 'Войдите с помощью {service}',
    email_placeholder: 'Адрес эл. почты',
    code_placeholder: '5-значный код',
    have_code: 'У меня есть код',
    email_code: 'Отправить код письмом',
    send_new_code: 'Отправить новый код',
    check_email:
      'Проверьте электронную почту на наличие письма с кодом и введите код здесь.',
    login_disclaimer:
      'Контент, созданный пользователями для {game}, обрабатывает mod.io.',
    terms_disclaimer: `Нажимая «Войдите», вы соглашаетесь с {studioterms}{terms} и {privacy} mod.io и подтверждаете, что вам исполнилось {min_age} лет или больше.`,
    terms_disclaimer_studio: '{terms} {studio}, c ',
    terms_disclaimer_studio_separator: ', ',
    terms_disclaimer_studio_and: ' и ',
    code_error: 'Не удается запросить код.',
    or: 'или',

    // Terms
    terms: 'Условия использования',
    privacy: 'Политика конфиденциальности',
    aup: 'Политика приемлемого использования',
    monetization: 'Условия монетизации',
    game: 'Условия игры',
    api: 'Условия доступа к API',
    effective: 'Действует с',

    // Report
    report_heading: 'Пожаловаться на этот мод',
    report_intro:
      'Пожалуйтесь на содержимое, нарушающее {terms} сайта. {dmca} (форма ниже) нужна для случаев предположительного нарушения авторских прав. При заполнении не забудьте указать всю необходимую информацию и предоставить ссылки.',
    dmca: 'Жалоба на нарушение авторского права',
    reason: 'Основания для жалобы',
    urls: 'URL-адреса материалов, нарушающих авторское право',
    urls_placeholder: 'URL-адреса (по 1 в строке)',
    company_or_name: 'Название компании или ваше имя',
    email: 'Адрес эл. почты',
    address: 'Адрес',
    country: 'Страна',
    country_placeholder: 'Выберите страну',
    details: 'Подробности о нарушении авторского права',
    details_placeholder:
      'Вы поможете нам обработать вашу жалобу, если предоставите как можно больше информации, а также доказательства нарушения, включая:\n\nURL-адреса, даты, имена вовлеченных учетных записей;\nуказание, где можно ознакомиться с оригинальной работой;\nописание произошедшего нарушения.',
    dmca_1:
      '{mod_io} уважает владельцев прав на интеллектуальную собственность и призывает к этому всех, кто пользуется нашими сайтами и службами. Если вы считаете, что ваша работа была использована на наших сайтах или в службах с нарушением авторского права, вы можете уведомить об этом агента по авторским правам в mod.io, используя форму ниже.',
    dmca_2:
      'Подача иска о нарушении авторского права — серьезный правовой вопрос. Перед тем, как продолжить, вы могли бы связаться с нарушителем и попытаться разрешить проблему напрямую с ним. Возможно, возникло простое недоразумение, которое можно урегулировать без привлечения надлежащих правовых процессов.',
    dmca_3:
      'Помните: в соответствии с разделом 512(f) Закона об авторском праве в цифровую эпоху, лицо, сообщившее заведомо ложные сведения о нарушении авторского права, может быть привлечено к ответственности за причиненный ущерб. Также обратите внимание, что информация, указанная в этом юридическом уведомлении, может быть передана третьим сторонам или стать общедоступной.',
    claim_check:
      'Проставляя отметки и отправляя эту форму, я заявляю, НЕСЯ ОТВЕТСТВЕННОСТЬ ЗА ЛЖЕСВИДЕТЕЛЬСТВО, что:',
    copyright_owner: 'я являюсь правообладателем;',
    copyright_auth_owner:
      'я имею полномочия действовать от имени владельца авторских прав в этой ситуации.',
    authorization: 'Наличие разрешения',
    authorization_check:
      'Я добросовестно полагаю, что использование материалов, указанных в этом заявлении, не разрешено владельцем авторских прав, его представителем или законом.',
    acknowledgement: 'Подтверждение',
    acknowledgement_check:
      'Я понимаю, что в соответствии с разделом 512(f) Закона об авторском праве в цифровую эпоху (DMCA), лицо, сообщившее заведомо ложные сведения о нарушении авторского права, несет ответственность за причиненный ущерб.',
    required: 'обязательное поле',
    signature: 'Цифровая подпись',
    signature_placeholder:
      'Введите в это поле свое полное имя, которое будет использоваться в качестве цифровой подписи.',
    report_success_title: 'Ваша жалоба была получена',
    report_success_text:
      'Если ваше сообщение требует ответа, проявите немного терпения. Мы стараемся отвечать на все жалобы в течение 48 часов с момента их получения.',
    report_error_title: 'Не удалось отправить жалобу',

    // Table
    name: 'Название',
    added: 'Добавлен',
    updated: 'Обновлен',
    file: 'Файл',
    version: 'Версия',
    actions: 'Действия',
    locally_installed: 'На устройстве',

    // Releases
    download_from_game_client: 'Загрузить мод {mod} из клиента игры',
    release_notes: 'Сведения о версии',
    no_release_notes: 'Сведения о версии не указаны',
    previous_releases: 'Предыдущие версии',
    view_previous_releases: 'Посмотреть предыдущие выпуски',
    no_previous_releases: 'Предыдущие версии отсутствуют',
    no_files_published: 'Нет опубликованных файлов',
    download_files_manually: 'Загрузка файлов вручную',
    platforms: 'Платформы',

    // Ratings
    overwhelmingly_positive: 'Крайне положительный',
    overwhelmingly_negative: 'Крайне отрицательный',
    very_positive: 'Очень положительный',
    very_negative: 'Очень отрицательный',
    mostly_positive: 'В основном положительный',
    mostly_negative: 'В основном отрицательный',
    negative: 'Отрицательный',
    positive: 'Положительный',
    mixed: 'Смешанный',
    unrated: 'Без рейтинга',

    // Sort
    sort_comments: 'Комментарии',
    sort_total_mods: 'Всего модов',
    sort_trending: 'В тренде',
    sort_highest_rated: 'Наивысший рейтинг',
    sort_most_popular: 'Самый популярный',
    sort_most_subscribers: 'Большинство подписчиков',
    sort_recently_added: 'Недавно добавленный',
    sort_last_updated: 'Последнее обновление',
    sort_alphabetical: 'Алфавитный',

    // Report Reason
    report_dmca: 'Закон о защите авторских прав в цифровую эпоху',
    report_not_working: 'Не работает',
    report_rude_content: 'Грубый контент',
    report_illegal_content: 'Незаконный контент',
    report_stolen_content: 'Украденный контент',
    report_false_information: 'Ложная информация',
    report_other: 'Другое',

    // Errors
    login_fail: 'Не удалось войти',
    login_fail_message:
      'Не удалось войти. Пожалуйста, подождите минутку и попробуйте еще раз.',
    subscribe_fail: 'Не удалось подписаться',
    unsubscribe_fail: 'Не удалось отписаться',

    agreement_not_found: 'Соглашение не найдено',
    form_chars_remaining: '{count} оставшиеся символы.',
    form_not_enough_chars: '{count} больше символов требуется.',
    filter: 'Фильтр',
    loading: 'Загрузка',
    next_version: 'Следующая версия',
    no_results_found: 'результатов не найдено',
    page_not_found: 'Страница не найдена!',
    previous_version: 'Предыдущая версия',
    take_me_home: 'Отведи меня домой',
    validation_alpha_num: 'Поле может содержать только цифры или буквы',
    validation_size: 'Поле должно быть {size} символы',
    validation_url: 'Поле должно быть URL',
    validation_max: 'Максимум {max} символы',
    validation_email: 'Поле должно быть электронным письмом',
    validation_checked: 'Поле должно быть проверено',
    validation_required: 'Поле, обязательное для заполнения',
    validation_name:
      'Поле может содержать только буквы и символы, относящиеся к имени.',

    comment: 'комментарий | комментарии',
    team_member: 'Участник команды',
    author: 'Автор',
    good_karma: 'Хорошая карма',
    bad_karma: 'Плохая карма',
    reply: 'Отвечать',
    replies: 'ответить | ответы',
    save: 'Сохранять',
    delete: 'Удалить',
    edit: 'Редактировать',
    post: 'Почта',
    pinned: 'Закреплено',
    locked: 'Заблокировано',
    add_comment: 'Добавить комментарий...',
    comment_login_prompt: 'Войдите, чтобы присоединиться к обсуждению!',
    comment_error_add: 'Не удалось добавить комментарий',
    comment_error_edit: 'Не удалось редактировать комментарий',
    comment_error_delete: 'Не удалось удалить комментарий',
    comments_error_fetch: 'Не удалось загрузить больше комментариев',
    discussion: 'Дискуссия',
    load_more_comments: 'Загрузите больше комментариев',
    comment_confirm_delete: 'Вы уверенны, что хотите удалить этот комментарий?',
    comment_deleted: 'Комментарий был успешно удален',
  },
  'zh-CN': {
    language: '语言',

    // Nav
    browse: '浏览',
    library: '图书馆',
    account: '我的账户',
    back: '返回',
    more: '更多的',

    // Guides
    guide: '指南|指南',
    views: '意见',
    table_of_contents: '目录',
    reading_time: '阅读时间',
    date_added: '添加日期',
    date_updated: '更新日期',
    minutes_read: '阅读分钟数',
    published: '已发表',

    // Users
    joined: '已加入',
    last_online: '最后在线时间',
    online: '在线的',
    created: '已创建',
    followers: '追随者',
    partner: '伙伴',
    profile_hidden: '该用户的个人资料已隐藏',

    // Mods
    mod: '模组',
    level: '水平|级别',
    content: '内容',
    subscribed: '已订阅',
    tags: '标签',
    summary: '概要',
    contributors: '作者',
    description: '描述',
    dependencies: '依赖项',
    of: '/',
    ago: '前',
    and: '和',
    by: '经过',
    reset_filters: '重置过滤器',
    show_more: '展示更多',
    show_less: '显示较少',
    no_ugc_found: '未找到 {ugc_name}',
    no_subscriptions: '你还没有订阅任何 {ugc_name}',
    mod_disclaimer_heading: '法律免责声明',
    mod_disclaimer_privacy: '请查看我们的隐私权政策',
    thumbs_up_received: '已收到竖起大拇指',
    thumbs_up: '竖起大拇指',
    total_downloads: '总下载量',
    releases: '发布',
    bytes: '字节',

    // Actions
    login: '登录',
    logout: '退出',
    search: '搜索',
    clear_all: '全部清除',
    download: '下载',
    subscribe: '订阅',
    unsubscribe: '取消订阅',
    resubscribe: '重新订阅',
    activate: '激活',
    deactivate: '停用',
    like: '赞',
    dislike: '踩',
    report: '报告一个问题',
    submit: '提交',
    cancel: '取消',

    // Filters
    all: '全部',
    available: '可用',
    filesize: '文件大小',
    downloads: '下载量',
    todays_downloads: '今日下载量',
    subscribers: '订阅者',
    rating: '评分',
    sort_by: '排序方式',
    creator: '创建者',
    apply: '申请',
    reset: '重置',
    featured: '特色',
    toggle_filters: '切换过滤器',
    hidden: '隐',
    pending: '待办的',
    deleted: '已删除',

    // Login
    signup: '使用电子邮件登录或注册',
    login_with: '使用 {service} 登录',
    email_placeholder: '电子邮件地址',
    code_placeholder: '5 位代码',
    have_code: '我有代码',
    email_code: '通过电子邮件发送代码',
    send_new_code: '发送新代码',
    check_email: '请查看你的电子邮件获取代码并在这里输入。',
    login_disclaimer: '{game} 的用户生成内容由 mod.io 管理。',
    terms_disclaimer: `按“登录”即表示您同意 {studioterms}mod.io 的{terms}和{privacy}，并确认您已年满 {min_age} 岁。`,
    terms_disclaimer_studio: '{studio} 的{terms}、',
    terms_disclaimer_studio_separator: '、',
    terms_disclaimer_studio_and: '和',
    code_error: '无法请求代码。',
    or: '或者',

    // Terms
    terms: '使用条款',
    privacy: '隐私政策',
    aup: '可接受的使用政策',
    monetization: '获利条款',
    game: '游戏条款',
    api: 'API访问条款',
    effective: '生效日期：',

    // Report
    report_heading: '举报此 mod',
    report_intro:
      '举报违反网站{terms}的内容或使用以下表单提交 {dmca}。确保包含所有相关信息和链接。',
    dmca: 'DMCA 投诉',
    reason: '举报原因',
    urls: '违规网址',
    urls_placeholder: '网址（每行 1 个）',
    company_or_name: '公司或你的名字',
    email: '电子邮件',
    address: '地址',
    country: '国家/地区',
    country_placeholder: '选择国家/地区',
    details: '侵权详情',
    details_placeholder:
      '为了让我们更好地处理举报，请提供尽可能多的详细信息和证据，包括\n\n涉及的网址、日期、帐户名\n可以找到原始内容的位置\n发生的侵权行为',
    dmca_1:
      '{mod_io} 尊重他人的知识产权，我们要求每个使用我们网站和服务的人都这样做。如果你认为你的作品在我们的网站或服务中被以侵权版权的方式重现，你可以使用以下表单通知 mod.io 的版权代理。',
    dmca_2:
      '提交版权侵犯申诉是一项严肃的法律事务。在继续之前，你可以考虑直接联系当事人以解决投诉。这可能只是一个误会，可以在不涉及适当法律程序的情况下解决。',
    dmca_3:
      '请注意，根据《数字千年版权法案》第 512(f) 条，任何人如果故意歪曲材料或活动侵权，则可能需要承担损害赔偿责任。另请注意，本法律声明中提供的信息可能会与第三方共享或公开。',
    claim_check: '勾选以下方框并提交此申诉，如有伪证则将受罚，我声明',
    copyright_owner: '我是版权所有者',
    copyright_auth_owner: '在这种情况下，我被授权代表版权所有者行事。',
    authorization: '授权',
    authorization_check:
      '我有正当理由相信，本声明中所述材料的使用未经版权所有者、其代理人或法律授权。',
    acknowledgement: '知悉书',
    acknowledgement_check:
      '我知悉，根据 DMCA 第 512(f) 条，任何人如果故意歪曲材料或活动侵权，则可能需要承担损害赔偿责任。',
    required: '必填',
    signature: '签名',
    signature_placeholder: '在此框中输入你的全名，作为你的数字签名。',
    report_success_title: '你的举报已送达',
    report_success_text:
      '如果你的消息需要回复，请耐心等待，我们会尽力在收到举报后的 48 小时内回复。',
    report_error_title: '提交举报失败',

    // Table
    name: '名称',
    added: '存在时长',
    updated: '更新日期',
    file: '文件',
    version: '版本',
    actions: '操作',
    locally_installed: '本地安装',

    // Releases
    download_from_game_client: '从游戏客户端下载 {mod}',
    release_notes: '版本说明',
    no_release_notes: '未提供版本说明',
    previous_releases: '之前的版本',
    view_previous_releases: '查看以前的版本',
    no_previous_releases: '没有之前的版本',
    no_files_published: '未发布文件',
    download_files_manually: '手动下载文件',
    platforms: '平台',

    // Ratings
    overwhelmingly_positive: '好评如潮',
    overwhelmingly_negative: '差评如潮',
    very_positive: '特别好评',
    very_negative: '特别差评',
    mostly_positive: '多半好评',
    mostly_negative: '多半差评',
    negative: '差评',
    positive: '好评',
    mixed: '褒贬不一',
    unrated: '未评分',

    // Sort
    sort_comments: '评论',
    sort_total_mods: '模组总数',
    sort_trending: '热门',
    sort_highest_rated: '收视率最高',
    sort_most_popular: '最受欢迎',
    sort_most_subscribers: '大多数订阅者',
    sort_recently_added: '最近添加的',
    sort_last_updated: '最近更新时间',
    sort_alphabetical: '按字母顺序',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: '不工作',
    report_rude_content: '粗鲁的内容',
    report_illegal_content: '非法内容',
    report_stolen_content: '被盗内容',
    report_false_information: '虚假信息',
    report_other: '其他',

    // Errors
    login_fail: '登录失败',
    login_fail_message: '登录失败。请等待一分钟，然后重试。',
    subscribe_fail: '未能订阅',
    unsubscribe_fail: '未能取消订阅',

    agreement_not_found: '未找到协议',
    form_chars_remaining: '{count}剩下的字符。',
    form_not_enough_chars: '{count}需要更多字符。',
    filter: '筛选',
    loading: '加载',
    next_version: '下一个版本',
    no_results_found: '未找到结果',
    page_not_found: '找不到网页！',
    previous_version: '以前的版本',
    take_me_home: '带我回家',
    validation_alpha_num: '字段只能包含数字或字母',
    validation_size: '字段必须为{size}字符',
    validation_url: '字段必须是一个URL',
    validation_max: '最大{max}字符',
    validation_email: '字段必须是一封电子邮件',
    validation_checked: '必须检查字段',
    validation_required: '需要字段',
    validation_name: '字段只能包含字母和与名称相关的符号',

    comment: '评论',
    team_member: '队员',
    author: '作者',
    good_karma: '顶',
    bad_karma: '踩',
    reply: '回复',
    replies: '回复|回复',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    post: '发布',
    pinned: '已固定',
    locked: '锁定',
    add_comment: '添加评论...',
    comment_login_prompt: '登录以加入讨论！',
    comment_error_add: '未能添加评论',
    comment_error_edit: '未能编辑评论',
    comment_error_delete: '无法删除评论',
    comments_error_fetch: '无法加载更多评论',
    discussion: '讨论',
    load_more_comments: '加载更多评论',
    comment_confirm_delete: '你确定要删除此评论吗？',
    comment_deleted: '评论已成功删除',
  },
  'zh-TW': {
    language: '語言',

    // Nav
    browse: '瀏覽',
    library: '圖書館',
    account: '我的賬戶',
    back: '返回',
    more: '更多的',

    // Guides
    guide: '指南|指南',
    views: '意見',
    table_of_contents: '目錄',
    reading_time: '閱讀時間',
    date_added: '新增日期',
    date_updated: '更新日期',
    minutes_read: '閱讀分鐘數',
    published: '已發表',

    // Users
    joined: '已加入',
    last_online: '最後在線時間',
    online: '在線的',
    created: '已創建',
    followers: '追隨者',
    partner: '夥伴',
    profile_hidden: '該用戶的個人資料已隱藏',

    // Mods
    mod: '模組',
    level: '水平|等級',
    content: '內容',
    subscribed: '已訂閱',
    tags: '標籤',
    summary: '摘要',
    contributors: '作者',
    description: '說明',
    dependencies: '依賴項',
    of: '/',
    ago: '前',
    and: '和',
    by: '經過',
    reset_filters: '重置過濾器',
    show_more: '展示更多',
    show_less: '顯示較少',
    no_ugc_found: '未找到 {ugc_name}',
    no_subscriptions: '你還沒有訂閱任何 {ugc_name}',
    mod_disclaimer_heading: '法律免責聲明',
    mod_disclaimer_privacy: '隱私權政策',
    thumbs_up_received: '已收到豎起大拇指',
    thumbs_up: '豎起大拇指',
    total_downloads: '總下載量',
    releases: '發布',
    bytes: '位元組',

    // Actions
    login: '登入',
    logout: '登出',
    search: '搜尋',
    clear_all: '全部清除',
    download: '下載',
    subscribe: '訂閱',
    unsubscribe: '取消訂閱',
    resubscribe: '重新訂閱',
    activate: '啟用',
    deactivate: '停用',
    like: '喜歡',
    dislike: '不喜歡',
    report: '報告一個問題',
    submit: '提交',
    cancel: '取消',

    // Filters
    all: '全部',
    available: '可用',
    filesize: '檔案大小',
    downloads: '下載次數',
    todays_downloads: '本日下載次數',
    subscribers: '訂閱者',
    rating: '評分',
    sort_by: '排序方式',
    creator: '建立者',
    apply: '申請',
    reset: '重置',
    featured: '特色',
    toggle_filters: '切換過濾器',
    hidden: '隱',
    pending: '待辦的',
    deleted: '已刪除',

    // Login
    signup: '以電子郵件登入或註冊',
    login_with: '使用 {service} 登入',
    email_placeholder: '電子郵件地址',
    code_placeholder: '5 位代碼',
    have_code: '我有代碼',
    email_code: '透過電子郵件傳送代碼',
    send_new_code: '傳送新代碼',
    check_email: '請檢查你電子郵件中的代碼，並在此處輸入。',
    login_disclaimer: '使用者為「{game}」產生的內容由 mod.io 管理。',
    terms_disclaimer: `按下「登入」即表示您同意 {studioterms}mod.io 的{terms}和{privacy}，並確認您已年滿 {min_age} 歲。`,
    terms_disclaimer_studio: '{studio} 的{terms}、',
    terms_disclaimer_studio_separator: '、',
    terms_disclaimer_studio_and: '和',
    code_error: '無法要求代碼。',
    or: '或者',

    // Terms
    terms: '使用條款',
    privacy: '隱私權政策',
    aup: '可接受的使用政策',
    monetization: '獲利條款',
    game: '遊戲條款',
    api: 'API存取條款',
    effective: '生效日期：',

    // Report
    report_heading: '檢舉此 mod',
    report_intro:
      '請使用下方表格來檢舉違反網站 {terms} 的內容或提交 {dmca}。請務必包含所有相關的資訊和連結。',
    dmca: 'DMCA 投訴',
    reason: '檢舉的原因',
    urls: '違規網址',
    urls_placeholder: '網址 (每行 1 個)',
    company_or_name: '公司或你的姓名',
    email: '電子郵件',
    address: '地址',
    country: '國家/地區',
    country_placeholder: '選取國家/地區',
    details: '侵權或違規的細節',
    details_placeholder:
      '為了協助我們處理你的報告，請盡量提供細節和證據，包括\n侵權或違規的網址、日期、帳戶名稱\n在哪裡可以找到原始內容\n已發生的侵權行為',
    dmca_1:
      '{mod_io} 尊重他人的智慧財產權，也要求每個使用我們網站和服務的人也這麼做。如果有人認為自己的作品在我們的網站或服務中遭到複製，從而構成著作權侵犯，請使用下方的表格來通知 mod.io 的著作權代理人。',
    dmca_2:
      '提出侵犯著作權的申訴是一件嚴肅的法律事務。在你繼續之前，或許可以考慮直接聯繫涉及此事的個人來解決問題。這可能只是一個簡單的誤會，或許不用牽涉到正式的法律程序也能處理。',
    dmca_3:
      '請注意，根據數位千禧年著作權法案第 512(f) 款，如有任何人明知不實仍陳述某些材料或活動侵犯著作權，均可能承擔損害賠償責任。另外，請注意，這份法律通知中提供的資訊可能會與第三方分享或公開。',
    claim_check: '透過勾選以下方塊並提交本申訴，我依法據實陳述',
    copyright_owner: '我是著作權所有人',
    copyright_auth_owner: '在此種情況下，我有權代表著作權所有人行事。',
    authorization: '授權',
    authorization_check:
      '我有正當理由相信，本申訴所指材料之使用，未經著作權所有人、其代理人或法律授權。',
    acknowledgement: '知悉書',
    acknowledgement_check:
      '我知悉，根據數位千禧年著作權法案第 512(f) 款，任何明知不實仍陳述某些材料或活動侵犯著作權者，均可能承擔損害賠償責任。',
    required: '必填',
    signature: '簽名',
    signature_placeholder: '在此框中鍵入你的全名，作為你的數位簽名。',
    report_success_title: '你的檢舉已送達',
    report_success_text:
      '如果你的訊息需要回覆，請耐心等待。我們會努力在收到檢舉後 48 小時內回覆。',
    report_error_title: '提交檢舉失敗',

    // Table
    name: '名稱',
    added: '建立時間',
    updated: '更新時間',
    file: '檔案',
    version: '版本',
    actions: '動作',
    locally_installed: '已安裝於本機',

    // Releases
    download_from_game_client: '從遊戲用戶端下載 {mod}',
    release_notes: '版本說明',
    no_release_notes: '未提供版本說明',
    previous_releases: '之前的版本',
    view_previous_releases: '查看先前的版本',
    no_previous_releases: '沒有之前的版本',
    no_files_published: '未發佈檔案',
    download_files_manually: '手動下載文件',
    platforms: '平台',

    // Ratings
    overwhelmingly_positive: '壓倒性好評',
    overwhelmingly_negative: '壓倒性負評',
    very_positive: '非常多好評',
    very_negative: '非常多負評',
    mostly_positive: '多數好評',
    mostly_negative: '多數負評',
    negative: '負評',
    positive: '好評',
    mixed: '褒貶不一',
    unrated: '未評分',

    // Sort
    sort_comments: '評論',
    sort_total_mods: '模組總數',
    sort_trending: '熱門',
    sort_highest_rated: '收視率最高',
    sort_most_popular: '最受歡迎',
    sort_most_subscribers: '大多數訂閱者',
    sort_recently_added: '最近添加的',
    sort_last_updated: '最近更新時間',
    sort_alphabetical: '按字母順序',

    // Report Reason
    report_dmca: 'DMCA',
    report_not_working: '不工作',
    report_rude_content: '粗魯的內容',
    report_illegal_content: '非法內容',
    report_stolen_content: '被盜內容',
    report_false_information: '虛假信息',
    report_other: '其他',

    // Errors
    login_fail: '登錄失敗',
    login_fail_message: '登錄失敗。請等待一分鐘，然後重試。',
    subscribe_fail: '未能訂閱',
    unsubscribe_fail: '未能取消訂閱',

    agreement_not_found: '未找到協議',
    form_chars_remaining: '{count}剩下的字符。',
    form_not_enough_chars: '{count}需要更多字符。',
    filter: '篩選',
    loading: '加載',
    next_version: '下一個版本',
    no_results_found: '未找到結果',
    page_not_found: '找不到網頁！',
    previous_version: '以前的版本',
    take_me_home: '帶我回家',
    validation_alpha_num: '字段只能包含數字或字母',
    validation_size: '字段必須為{size}字符',
    validation_url: '字段必須是一個URL',
    validation_max: '最大{max}字符',
    validation_email: '字段必須是一封電子郵件',
    validation_checked: '必須檢查字段',
    validation_required: '需要字段',
    validation_name: '欄位只能包含字母和與名稱相關的符號',

    comment: '評論',
    team_member: '隊員',
    author: '作者',
    good_karma: 'ding',
    bad_karma: '踩',
    reply: '回覆',
    replies: '回覆|回覆',
    save: '保存',
    delete: '刪除',
    edit: '編輯',
    post: '發佈',
    pinned: '已固定',
    locked: '鎖定',
    add_comment: '添加評論...',
    comment_login_prompt: '登錄以加入討論！',
    comment_error_add: '未能添加評論',
    comment_error_edit: '未能編輯評論',
    comment_error_delete: '無法刪除評論',
    comments_error_fetch: '無法加載更多評論',
    discussion: '討論',
    load_more_comments: '加載更多評論',
    comment_confirm_delete: '你確定要刪除此評論嗎？',
    comment_deleted: '評論已成功刪除',
  },
}
